(function() {
  if (typeof window != "object")
    return;
  if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
    "isIntersecting" in window.IntersectionObserverEntry.prototype || Object.defineProperty(
      window.IntersectionObserverEntry.prototype,
      "isIntersecting",
      {
        get: function() {
          return this.intersectionRatio > 0;
        }
      }
    );
    return;
  }
  function r(p) {
    try {
      return p.defaultView && p.defaultView.frameElement || null;
    } catch {
      return null;
    }
  }
  var n = function(p) {
    for (var f = p, l = r(f); l; )
      f = l.ownerDocument, l = r(f);
    return f;
  }(window.document), a = [], s = null, h = null;
  function g(p) {
    this.time = p.time, this.target = p.target, this.rootBounds = H(p.rootBounds), this.boundingClientRect = H(p.boundingClientRect), this.intersectionRect = H(p.intersectionRect || D()), this.isIntersecting = !!p.intersectionRect;
    var f = this.boundingClientRect, l = f.width * f.height, t = this.intersectionRect, o = t.width * t.height;
    l ? this.intersectionRatio = Number((o / l).toFixed(4)) : this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
  function m(p, f) {
    var l = f || {};
    if (typeof p != "function")
      throw new Error("callback must be a function");
    if (l.root && l.root.nodeType != 1 && l.root.nodeType != 9)
      throw new Error("root must be a Document or Element");
    this._checkForIntersections = w(
      this._checkForIntersections.bind(this),
      this.THROTTLE_TIMEOUT
    ), this._callback = p, this._observationTargets = [], this._queuedEntries = [], this._rootMarginValues = this._parseRootMargin(l.rootMargin), this.thresholds = this._initThresholds(l.threshold), this.root = l.root || null, this.rootMargin = this._rootMarginValues.map(function(t) {
      return t.value + t.unit;
    }).join(" "), this._monitoringDocuments = [], this._monitoringUnsubscribes = [];
  }
  m.prototype.THROTTLE_TIMEOUT = 100, m.prototype.POLL_INTERVAL = null, m.prototype.USE_MUTATION_OBSERVER = !0, m._setupCrossOriginUpdater = function() {
    return s || (s = function(p, f) {
      !p || !f ? h = D() : h = W(p, f), a.forEach(function(l) {
        l._checkForIntersections();
      });
    }), s;
  }, m._resetCrossOriginUpdater = function() {
    s = null, h = null;
  }, m.prototype.observe = function(p) {
    var f = this._observationTargets.some(function(l) {
      return l.element == p;
    });
    if (!f) {
      if (!(p && p.nodeType == 1))
        throw new Error("target must be an Element");
      this._registerInstance(), this._observationTargets.push({ element: p, entry: null }), this._monitorIntersections(p.ownerDocument), this._checkForIntersections();
    }
  }, m.prototype.unobserve = function(p) {
    this._observationTargets = this._observationTargets.filter(function(f) {
      return f.element != p;
    }), this._unmonitorIntersections(p.ownerDocument), this._observationTargets.length == 0 && this._unregisterInstance();
  }, m.prototype.disconnect = function() {
    this._observationTargets = [], this._unmonitorAllIntersections(), this._unregisterInstance();
  }, m.prototype.takeRecords = function() {
    var p = this._queuedEntries.slice();
    return this._queuedEntries = [], p;
  }, m.prototype._initThresholds = function(p) {
    var f = p || [0];
    return Array.isArray(f) || (f = [f]), f.sort().filter(function(l, t, o) {
      if (typeof l != "number" || isNaN(l) || l < 0 || l > 1)
        throw new Error("threshold must be a number between 0 and 1 inclusively");
      return l !== o[t - 1];
    });
  }, m.prototype._parseRootMargin = function(p) {
    var f = p || "0px", l = f.split(/\s+/).map(function(t) {
      var o = /^(-?\d*\.?\d+)(px|%)$/.exec(t);
      if (!o)
        throw new Error("rootMargin must be specified in pixels or percent");
      return { value: parseFloat(o[1]), unit: o[2] };
    });
    return l[1] = l[1] || l[0], l[2] = l[2] || l[0], l[3] = l[3] || l[1], l;
  }, m.prototype._monitorIntersections = function(p) {
    var f = p.defaultView;
    if (f && this._monitoringDocuments.indexOf(p) == -1) {
      var l = this._checkForIntersections, t = null, o = null;
      this.POLL_INTERVAL ? t = f.setInterval(l, this.POLL_INTERVAL) : (R(f, "resize", l, !0), R(p, "scroll", l, !0), this.USE_MUTATION_OBSERVER && "MutationObserver" in f && (o = new f.MutationObserver(l), o.observe(p, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      }))), this._monitoringDocuments.push(p), this._monitoringUnsubscribes.push(function() {
        var E = p.defaultView;
        E && (t && E.clearInterval(t), S(E, "resize", l, !0)), S(p, "scroll", l, !0), o && o.disconnect();
      });
      var u = this.root && (this.root.ownerDocument || this.root) || n;
      if (p != u) {
        var y = r(p);
        y && this._monitorIntersections(y.ownerDocument);
      }
    }
  }, m.prototype._unmonitorIntersections = function(p) {
    var f = this._monitoringDocuments.indexOf(p);
    if (f != -1) {
      var l = this.root && (this.root.ownerDocument || this.root) || n, t = this._observationTargets.some(function(y) {
        var E = y.element.ownerDocument;
        if (E == p)
          return !0;
        for (; E && E != l; ) {
          var P = r(E);
          if (E = P && P.ownerDocument, E == p)
            return !0;
        }
        return !1;
      });
      if (!t) {
        var o = this._monitoringUnsubscribes[f];
        if (this._monitoringDocuments.splice(f, 1), this._monitoringUnsubscribes.splice(f, 1), o(), p != l) {
          var u = r(p);
          u && this._unmonitorIntersections(u.ownerDocument);
        }
      }
    }
  }, m.prototype._unmonitorAllIntersections = function() {
    var p = this._monitoringUnsubscribes.slice(0);
    this._monitoringDocuments.length = 0, this._monitoringUnsubscribes.length = 0;
    for (var f = 0; f < p.length; f++)
      p[f]();
  }, m.prototype._checkForIntersections = function() {
    if (!(!this.root && s && !h)) {
      var p = this._rootIsInDom(), f = p ? this._getRootRect() : D();
      this._observationTargets.forEach(function(l) {
        var t = l.element, o = C(t), u = this._rootContainsTarget(t), y = l.entry, E = p && u && this._computeTargetAndRootIntersection(t, o, f), P = null;
        this._rootContainsTarget(t) ? (!s || this.root) && (P = f) : P = D();
        var F = l.entry = new g({
          time: v(),
          target: t,
          boundingClientRect: o,
          rootBounds: P,
          intersectionRect: E
        });
        y ? p && u ? this._hasCrossedThreshold(y, F) && this._queuedEntries.push(F) : y && y.isIntersecting && this._queuedEntries.push(F) : this._queuedEntries.push(F);
      }, this), this._queuedEntries.length && this._callback(this.takeRecords(), this);
    }
  }, m.prototype._computeTargetAndRootIntersection = function(p, f, l) {
    if (window.getComputedStyle(p).display != "none") {
      for (var t = f, o = z(p), u = !1; !u && o; ) {
        var y = null, E = o.nodeType == 1 ? window.getComputedStyle(o) : {};
        if (E.display == "none")
          return null;
        if (o == this.root || o.nodeType == /* DOCUMENT */
        9)
          if (u = !0, o == this.root || o == n)
            s && !this.root ? !h || h.width == 0 && h.height == 0 ? (o = null, y = null, t = null) : y = h : y = l;
          else {
            var P = z(o), F = P && C(P), x = P && this._computeTargetAndRootIntersection(P, F, l);
            F && x ? (o = P, y = W(F, x)) : (o = null, t = null);
          }
        else {
          var $ = o.ownerDocument;
          o != $.body && o != $.documentElement && E.overflow != "visible" && (y = C(o));
        }
        if (y && (t = O(y, t)), !t)
          break;
        o = o && z(o);
      }
      return t;
    }
  }, m.prototype._getRootRect = function() {
    var p;
    if (this.root && !Z(this.root))
      p = C(this.root);
    else {
      var f = Z(this.root) ? this.root : n, l = f.documentElement, t = f.body;
      p = {
        top: 0,
        left: 0,
        right: l.clientWidth || t.clientWidth,
        width: l.clientWidth || t.clientWidth,
        bottom: l.clientHeight || t.clientHeight,
        height: l.clientHeight || t.clientHeight
      };
    }
    return this._expandRectByRootMargin(p);
  }, m.prototype._expandRectByRootMargin = function(p) {
    var f = this._rootMarginValues.map(function(t, o) {
      return t.unit == "px" ? t.value : t.value * (o % 2 ? p.width : p.height) / 100;
    }), l = {
      top: p.top - f[0],
      right: p.right + f[1],
      bottom: p.bottom + f[2],
      left: p.left - f[3]
    };
    return l.width = l.right - l.left, l.height = l.bottom - l.top, l;
  }, m.prototype._hasCrossedThreshold = function(p, f) {
    var l = p && p.isIntersecting ? p.intersectionRatio || 0 : -1, t = f.isIntersecting ? f.intersectionRatio || 0 : -1;
    if (l !== t)
      for (var o = 0; o < this.thresholds.length; o++) {
        var u = this.thresholds[o];
        if (u == l || u == t || u < l != u < t)
          return !0;
      }
  }, m.prototype._rootIsInDom = function() {
    return !this.root || N(n, this.root);
  }, m.prototype._rootContainsTarget = function(p) {
    var f = this.root && (this.root.ownerDocument || this.root) || n;
    return N(f, p) && (!this.root || f == p.ownerDocument);
  }, m.prototype._registerInstance = function() {
    a.indexOf(this) < 0 && a.push(this);
  }, m.prototype._unregisterInstance = function() {
    var p = a.indexOf(this);
    p != -1 && a.splice(p, 1);
  };
  function v() {
    return window.performance && performance.now && performance.now();
  }
  function w(p, f) {
    var l = null;
    return function() {
      l || (l = setTimeout(function() {
        p(), l = null;
      }, f));
    };
  }
  function R(p, f, l, t) {
    typeof p.addEventListener == "function" ? p.addEventListener(f, l, t || !1) : typeof p.attachEvent == "function" && p.attachEvent("on" + f, l);
  }
  function S(p, f, l, t) {
    typeof p.removeEventListener == "function" ? p.removeEventListener(f, l, t || !1) : typeof p.detachEvent == "function" && p.detachEvent("on" + f, l);
  }
  function O(p, f) {
    var l = Math.max(p.top, f.top), t = Math.min(p.bottom, f.bottom), o = Math.max(p.left, f.left), u = Math.min(p.right, f.right), y = u - o, E = t - l;
    return y >= 0 && E >= 0 && {
      top: l,
      bottom: t,
      left: o,
      right: u,
      width: y,
      height: E
    } || null;
  }
  function C(p) {
    var f;
    try {
      f = p.getBoundingClientRect();
    } catch {
    }
    return f ? (f.width && f.height || (f = {
      top: f.top,
      right: f.right,
      bottom: f.bottom,
      left: f.left,
      width: f.right - f.left,
      height: f.bottom - f.top
    }), f) : D();
  }
  function D() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }
  function H(p) {
    return !p || "x" in p ? p : {
      top: p.top,
      y: p.top,
      bottom: p.bottom,
      left: p.left,
      x: p.left,
      right: p.right,
      width: p.width,
      height: p.height
    };
  }
  function W(p, f) {
    var l = f.top - p.top, t = f.left - p.left;
    return {
      top: l,
      left: t,
      height: f.height,
      width: f.width,
      bottom: l + f.height,
      right: t + f.width
    };
  }
  function N(p, f) {
    for (var l = f; l; ) {
      if (l == p)
        return !0;
      l = z(l);
    }
    return !1;
  }
  function z(p) {
    var f = p.parentNode;
    return p.nodeType == /* DOCUMENT */
    9 && p != n ? r(p) : (f && f.assignedSlot && (f = f.assignedSlot.parentNode), f && f.nodeType == 11 && f.host ? f.host : f);
  }
  function Z(p) {
    return p && p.nodeType === 9;
  }
  window.IntersectionObserver = m, window.IntersectionObserverEntry = g;
})();
function getDefaultExportFromCjs(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var isEmail$1 = { exports: {} }, assertString = { exports: {} };
(function(r, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = s;
  function a(h) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(m) {
      return typeof m;
    } : a = function(m) {
      return m && typeof Symbol == "function" && m.constructor === Symbol && m !== Symbol.prototype ? "symbol" : typeof m;
    }, a(h);
  }
  function s(h) {
    var g = typeof h == "string" || h instanceof String;
    if (!g) {
      var m;
      throw h === null ? m = "null" : (m = a(h), m === "object" && h.constructor && h.constructor.hasOwnProperty("name") ? m = h.constructor.name : m = "a ".concat(m)), new TypeError("Expected string but received ".concat(m, "."));
    }
  }
  r.exports = n.default, r.exports.default = n.default;
})(assertString, assertString.exports);
var assertStringExports = assertString.exports, merge = { exports: {} };
(function(r, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;
  function a() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, h = arguments.length > 1 ? arguments[1] : void 0;
    for (var g in h)
      typeof s[g] > "u" && (s[g] = h[g]);
    return s;
  }
  r.exports = n.default, r.exports.default = n.default;
})(merge, merge.exports);
var mergeExports = merge.exports, isByteLength = { exports: {} };
(function(r, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = g;
  var a = s(assertStringExports);
  function s(m) {
    return m && m.__esModule ? m : { default: m };
  }
  function h(m) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? h = function(w) {
      return typeof w;
    } : h = function(w) {
      return w && typeof Symbol == "function" && w.constructor === Symbol && w !== Symbol.prototype ? "symbol" : typeof w;
    }, h(m);
  }
  function g(m, v) {
    (0, a.default)(m);
    var w, R;
    h(v) === "object" ? (w = v.min || 0, R = v.max) : (w = arguments[1], R = arguments[2]);
    var S = encodeURI(m).split(/%..|./).length - 1;
    return S >= w && (typeof R > "u" || S <= R);
  }
  r.exports = n.default, r.exports.default = n.default;
})(isByteLength, isByteLength.exports);
var isByteLengthExports = isByteLength.exports, isFQDN = { exports: {} };
(function(r, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = m;
  var a = h(assertStringExports), s = h(mergeExports);
  function h(v) {
    return v && v.__esModule ? v : { default: v };
  }
  var g = {
    require_tld: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1
  };
  function m(v, w) {
    (0, a.default)(v), w = (0, s.default)(w, g), w.allow_trailing_dot && v[v.length - 1] === "." && (v = v.substring(0, v.length - 1));
    for (var R = v.split("."), S = 0; S < R.length; S++)
      if (R[S].length > 63)
        return !1;
    if (w.require_tld) {
      var O = R.pop();
      if (!R.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(O) || /[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20\u00A9\uFFFD]/.test(O))
        return !1;
    }
    for (var C, D = 0; D < R.length; D++)
      if (C = R[D], w.allow_underscores && (C = C.replace(/_/g, "")), !/^[a-z\u00a1-\uffff0-9-]+$/i.test(C) || /[\uff01-\uff5e]/.test(C) || C[0] === "-" || C[C.length - 1] === "-")
        return !1;
    return !0;
  }
  r.exports = n.default, r.exports.default = n.default;
})(isFQDN, isFQDN.exports);
var isFQDNExports = isFQDN.exports, isIP = { exports: {} };
(function(r, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = m;
  var a = s(assertStringExports);
  function s(v) {
    return v && v.__esModule ? v : { default: v };
  }
  var h = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/, g = /^[0-9A-F]{1,4}$/i;
  function m(v) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if ((0, a.default)(v), w = String(w), w) {
      if (w === "4") {
        if (!h.test(v))
          return !1;
        var R = v.split(".").sort(function(N, z) {
          return N - z;
        });
        return R[3] <= 255;
      } else if (w === "6") {
        var S = [v];
        if (v.includes("%") && (S = v.split("%"), S.length !== 2 || !S[0].includes(":") || S[1] === ""))
          return !1;
        var O = S[0].split(":"), C = !1, D = m(O[O.length - 1], 4), H = D ? 7 : 8;
        if (O.length > H)
          return !1;
        if (v === "::")
          return !0;
        v.substr(0, 2) === "::" ? (O.shift(), O.shift(), C = !0) : v.substr(v.length - 2) === "::" && (O.pop(), O.pop(), C = !0);
        for (var W = 0; W < O.length; ++W)
          if (O[W] === "" && W > 0 && W < O.length - 1) {
            if (C)
              return !1;
            C = !0;
          } else if (!(D && W === O.length - 1)) {
            if (!g.test(O[W]))
              return !1;
          }
        return C ? O.length >= 1 : O.length === H;
      }
    } else
      return m(v, 4) || m(v, 6);
    return !1;
  }
  r.exports = n.default, r.exports.default = n.default;
})(isIP, isIP.exports);
var isIPExports = isIP.exports;
(function(r, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = o;
  var a = v(assertStringExports), s = v(mergeExports), h = v(isByteLengthExports), g = v(isFQDNExports), m = v(isIPExports);
  function v(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function w(u, y) {
    return D(u) || C(u, y) || S(u, y) || R();
  }
  function R() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function S(u, y) {
    if (u) {
      if (typeof u == "string")
        return O(u, y);
      var E = Object.prototype.toString.call(u).slice(8, -1);
      if (E === "Object" && u.constructor && (E = u.constructor.name), E === "Map" || E === "Set")
        return Array.from(u);
      if (E === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(E))
        return O(u, y);
    }
  }
  function O(u, y) {
    (y == null || y > u.length) && (y = u.length);
    for (var E = 0, P = new Array(y); E < y; E++)
      P[E] = u[E];
    return P;
  }
  function C(u, y) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(u)))) {
      var E = [], P = !0, F = !1, x = void 0;
      try {
        for (var $ = u[Symbol.iterator](), V; !(P = (V = $.next()).done) && (E.push(V.value), !(y && E.length === y)); P = !0)
          ;
      } catch (re) {
        F = !0, x = re;
      } finally {
        try {
          !P && $.return != null && $.return();
        } finally {
          if (F)
            throw x;
        }
      }
      return E;
    }
  }
  function D(u) {
    if (Array.isArray(u))
      return u;
  }
  var H = {
    allow_display_name: !1,
    require_display_name: !1,
    allow_utf8_local_part: !0,
    require_tld: !0
  }, W = /^([^\x00-\x1F\x7F-\x9F\cX]+)<(.+)>$/i, N = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, z = /^[a-z\d]+$/, Z = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, p = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, f = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, l = 254;
  function t(u) {
    var y = u.match(/^"(.+)"$/i), E = y ? y[1] : u;
    if (!E.trim())
      return !1;
    var P = /[\.";<>]/.test(E);
    if (P) {
      if (!y)
        return !1;
      var F = E.split('"').length === E.split('\\"').length;
      if (!F)
        return !1;
    }
    return !0;
  }
  function o(u, y) {
    if ((0, a.default)(u), y = (0, s.default)(y, H), y.require_display_name || y.allow_display_name) {
      var E = u.match(W);
      if (E) {
        var P, F = w(E, 3);
        if (P = F[1], u = F[2], P.endsWith(" ") && (P = P.substr(0, P.length - 1)), !t(P))
          return !1;
      } else if (y.require_display_name)
        return !1;
    }
    if (!y.ignore_max_length && u.length > l)
      return !1;
    var x = u.split("@"), $ = x.pop(), V = x.join("@"), re = $.toLowerCase();
    if (y.domain_specific_validation && (re === "gmail.com" || re === "googlemail.com")) {
      V = V.toLowerCase();
      var _ = V.split("+")[0];
      if (!(0, h.default)(_.replace(".", ""), {
        min: 6,
        max: 30
      }))
        return !1;
      for (var A = _.split("."), U = 0; U < A.length; U++)
        if (!z.test(A[U]))
          return !1;
    }
    if (!(0, h.default)(V, {
      max: 64
    }) || !(0, h.default)($, {
      max: 254
    }))
      return !1;
    if (!(0, g.default)($, {
      require_tld: y.require_tld
    })) {
      if (!y.allow_ip_domain)
        return !1;
      if (!(0, m.default)($)) {
        if (!$.startsWith("[") || !$.endsWith("]"))
          return !1;
        var G = $.substr(1, $.length - 2);
        if (G.length === 0 || !(0, m.default)(G))
          return !1;
      }
    }
    if (V[0] === '"')
      return V = V.slice(1, V.length - 1), y.allow_utf8_local_part ? f.test(V) : Z.test(V);
    for (var J = y.allow_utf8_local_part ? p : N, Q = V.split("."), X = 0; X < Q.length; X++)
      if (!J.test(Q[X]))
        return !1;
    return !0;
  }
  r.exports = n.default, r.exports.default = n.default;
})(isEmail$1, isEmail$1.exports);
var isEmailExports = isEmail$1.exports;
const isEmail = /* @__PURE__ */ getDefaultExportFromCjs(isEmailExports);
var isNumeric$1 = { exports: {} }, alpha$1 = {};
Object.defineProperty(alpha$1, "__esModule", {
  value: !0
});
alpha$1.commaDecimal = alpha$1.dotDecimal = alpha$1.arabicLocales = alpha$1.englishLocales = alpha$1.decimal = alpha$1.alphanumeric = alpha$1.alpha = void 0;
var alpha = {
  "en-US": /^[A-Z]+$/i,
  "bg-BG": /^[А-Я]+$/i,
  "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[A-ZÆØÅ]+$/i,
  "de-DE": /^[A-ZÄÖÜß]+$/i,
  "el-GR": /^[Α-ώ]+$/i,
  "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "nb-NO": /^[A-ZÆØÅ]+$/i,
  "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[A-ZÆØÅ]+$/i,
  "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[А-ЯЁ]+$/i,
  "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[A-ZÅÄÖ]+$/i,
  "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
  "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[א-ת]+$/,
  "fa-IR": /^['آابپتثجچهخدذرزژسشصضطظعغفقکگلمنوهی']+$/i
};
alpha$1.alpha = alpha;
var alphanumeric = {
  "en-US": /^[0-9A-Z]+$/i,
  "bg-BG": /^[0-9А-Я]+$/i,
  "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  "da-DK": /^[0-9A-ZÆØÅ]+$/i,
  "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
  "el-GR": /^[0-9Α-ω]+$/i,
  "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
  "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
  "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
  "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
  "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
  "ru-RU": /^[0-9А-ЯЁ]+$/i,
  "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
  "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
  "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
  "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
  "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
  he: /^[0-9א-ת]+$/,
  "fa-IR": /^['0-9آابپتثجچهخدذرزژسشصضطظعغفقکگلمنوهی۱۲۳۴۵۶۷۸۹۰']+$/i
};
alpha$1.alphanumeric = alphanumeric;
var decimal = {
  "en-US": ".",
  ar: "٫"
};
alpha$1.decimal = decimal;
var englishLocales = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"];
alpha$1.englishLocales = englishLocales;
for (var locale, i = 0; i < englishLocales.length; i++)
  locale = "en-".concat(englishLocales[i]), alpha[locale] = alpha["en-US"], alphanumeric[locale] = alphanumeric["en-US"], decimal[locale] = decimal["en-US"];
var arabicLocales = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"];
alpha$1.arabicLocales = arabicLocales;
for (var _locale, _i = 0; _i < arabicLocales.length; _i++)
  _locale = "ar-".concat(arabicLocales[_i]), alpha[_locale] = alpha.ar, alphanumeric[_locale] = alphanumeric.ar, decimal[_locale] = decimal.ar;
var dotDecimal = ["ar-EG", "ar-LB", "ar-LY"];
alpha$1.dotDecimal = dotDecimal;
var commaDecimal = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "es-ES", "fr-FR", "it-IT", "ku-IQ", "hu-HU", "nb-NO", "nn-NO", "nl-NL", "pl-PL", "pt-PT", "ru-RU", "sl-SI", "sr-RS@latin", "sr-RS", "sv-SE", "tr-TR", "uk-UA"];
alpha$1.commaDecimal = commaDecimal;
for (var _i2 = 0; _i2 < dotDecimal.length; _i2++)
  decimal[dotDecimal[_i2]] = decimal["en-US"];
for (var _i3 = 0; _i3 < commaDecimal.length; _i3++)
  decimal[commaDecimal[_i3]] = ",";
alpha["pt-BR"] = alpha["pt-PT"];
alphanumeric["pt-BR"] = alphanumeric["pt-PT"];
decimal["pt-BR"] = decimal["pt-PT"];
alpha["pl-Pl"] = alpha["pl-PL"];
alphanumeric["pl-Pl"] = alphanumeric["pl-PL"];
decimal["pl-Pl"] = decimal["pl-PL"];
(function(r, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = m;
  var a = h(assertStringExports), s = alpha$1;
  function h(v) {
    return v && v.__esModule ? v : { default: v };
  }
  var g = /^[0-9]+$/;
  function m(v, w) {
    return (0, a.default)(v), w && w.no_symbols ? g.test(v) : new RegExp("^[+-]?([0-9]*[".concat((w || {}).locale ? s.decimal[w.locale] : ".", "])?[0-9]+$")).test(v);
  }
  r.exports = n.default, r.exports.default = n.default;
})(isNumeric$1, isNumeric$1.exports);
var isNumericExports = isNumeric$1.exports;
const isNumeric = /* @__PURE__ */ getDefaultExportFromCjs(isNumericExports);
var isURL$1 = { exports: {} };
(function(r, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = O;
  var a = m(assertStringExports), s = m(isFQDNExports), h = m(isIPExports), g = m(mergeExports);
  function m(C) {
    return C && C.__esModule ? C : { default: C };
  }
  var v = {
    protocols: ["http", "https", "ftp"],
    require_tld: !0,
    require_protocol: !1,
    require_host: !0,
    require_valid_protocol: !0,
    allow_underscores: !1,
    allow_trailing_dot: !1,
    allow_protocol_relative_urls: !1
  }, w = /^\[([^\]]+)\](?::([0-9]+))?$/;
  function R(C) {
    return Object.prototype.toString.call(C) === "[object RegExp]";
  }
  function S(C, D) {
    for (var H = 0; H < D.length; H++) {
      var W = D[H];
      if (C === W || R(W) && W.test(C))
        return !0;
    }
    return !1;
  }
  function O(C, D) {
    if ((0, a.default)(C), !C || C.length >= 2083 || /[\s<>]/.test(C) || C.indexOf("mailto:") === 0)
      return !1;
    D = (0, g.default)(D, v);
    var H, W, N, z, Z, p, f, l;
    if (f = C.split("#"), C = f.shift(), f = C.split("?"), C = f.shift(), f = C.split("://"), f.length > 1) {
      if (H = f.shift().toLowerCase(), D.require_valid_protocol && D.protocols.indexOf(H) === -1)
        return !1;
    } else {
      if (D.require_protocol)
        return !1;
      if (C.substr(0, 2) === "//") {
        if (!D.allow_protocol_relative_urls)
          return !1;
        f[0] = C.substr(2);
      }
    }
    if (C = f.join("://"), C === "")
      return !1;
    if (f = C.split("/"), C = f.shift(), C === "" && !D.require_host)
      return !0;
    if (f = C.split("@"), f.length > 1 && (D.disallow_auth || (W = f.shift(), W.indexOf(":") >= 0 && W.split(":").length > 2)))
      return !1;
    z = f.join("@"), p = null, l = null;
    var t = z.match(w);
    return t ? (N = "", l = t[1], p = t[2] || null) : (f = z.split(":"), N = f.shift(), f.length && (p = f.join(":"))), !(p !== null && (Z = parseInt(p, 10), !/^[0-9]+$/.test(p) || Z <= 0 || Z > 65535) || !(0, h.default)(N) && !(0, s.default)(N, D) && (!l || !(0, h.default)(l, 6)) || (N = N || l, D.host_whitelist && !S(N, D.host_whitelist)) || D.host_blacklist && S(N, D.host_blacklist));
  }
  r.exports = n.default, r.exports.default = n.default;
})(isURL$1, isURL$1.exports);
var isURLExports = isURL$1.exports;
const isURL = /* @__PURE__ */ getDefaultExportFromCjs(isURLExports);
var isFloat$1 = {};
Object.defineProperty(isFloat$1, "__esModule", {
  value: !0
});
var _default = isFloat$1.default = isFloat;
isFloat$1.locales = void 0;
var _assertString = _interopRequireDefault(assertStringExports), _alpha = alpha$1;
function _interopRequireDefault(r) {
  return r && r.__esModule ? r : { default: r };
}
function isFloat(r, n) {
  (0, _assertString.default)(r), n = n || {};
  var a = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(n.locale ? _alpha.decimal[n.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
  if (r === "" || r === "." || r === "-" || r === "+")
    return !1;
  var s = parseFloat(r.replace(",", "."));
  return a.test(r) && (!n.hasOwnProperty("min") || s >= n.min) && (!n.hasOwnProperty("max") || s <= n.max) && (!n.hasOwnProperty("lt") || s < n.lt) && (!n.hasOwnProperty("gt") || s > n.gt);
}
var locales = Object.keys(_alpha.decimal);
isFloat$1.locales = locales;
var intlTelInput$3 = { exports: {} };
(function(r) {
  (function(n) {
    r.exports ? r.exports = n() : window.intlTelInput = n();
  })(function(n) {
    return function() {
      for (var a = [["Afghanistan (‫افغانستان‬‎)", "af", "93"], ["Albania (Shqipëri)", "al", "355"], ["Algeria (‫الجزائر‬‎)", "dz", "213"], ["American Samoa", "as", "1", 5, ["684"]], ["Andorra", "ad", "376"], ["Angola", "ao", "244"], ["Anguilla", "ai", "1", 6, ["264"]], ["Antigua and Barbuda", "ag", "1", 7, ["268"]], ["Argentina", "ar", "54"], ["Armenia (Հայաստան)", "am", "374"], ["Aruba", "aw", "297"], ["Ascension Island", "ac", "247"], ["Australia", "au", "61", 0], ["Austria (Österreich)", "at", "43"], ["Azerbaijan (Azərbaycan)", "az", "994"], ["Bahamas", "bs", "1", 8, ["242"]], ["Bahrain (‫البحرين‬‎)", "bh", "973"], ["Bangladesh (বাংলাদেশ)", "bd", "880"], ["Barbados", "bb", "1", 9, ["246"]], ["Belarus (Беларусь)", "by", "375"], ["Belgium (België)", "be", "32"], ["Belize", "bz", "501"], ["Benin (Bénin)", "bj", "229"], ["Bermuda", "bm", "1", 10, ["441"]], ["Bhutan (འབྲུག)", "bt", "975"], ["Bolivia", "bo", "591"], ["Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387"], ["Botswana", "bw", "267"], ["Brazil (Brasil)", "br", "55"], ["British Indian Ocean Territory", "io", "246"], ["British Virgin Islands", "vg", "1", 11, ["284"]], ["Brunei", "bn", "673"], ["Bulgaria (България)", "bg", "359"], ["Burkina Faso", "bf", "226"], ["Burundi (Uburundi)", "bi", "257"], ["Cambodia (កម្ពុជា)", "kh", "855"], ["Cameroon (Cameroun)", "cm", "237"], ["Canada", "ca", "1", 1, ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde (Kabu Verdi)", "cv", "238"], ["Caribbean Netherlands", "bq", "599", 1, ["3", "4", "7"]], ["Cayman Islands", "ky", "1", 12, ["345"]], ["Central African Republic (République centrafricaine)", "cf", "236"], ["Chad (Tchad)", "td", "235"], ["Chile", "cl", "56"], ["China (中国)", "cn", "86"], ["Christmas Island", "cx", "61", 2, ["89164"]], ["Cocos (Keeling) Islands", "cc", "61", 1, ["89162"]], ["Colombia", "co", "57"], ["Comoros (‫جزر القمر‬‎)", "km", "269"], ["Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243"], ["Congo (Republic) (Congo-Brazzaville)", "cg", "242"], ["Cook Islands", "ck", "682"], ["Costa Rica", "cr", "506"], ["Côte d’Ivoire", "ci", "225"], ["Croatia (Hrvatska)", "hr", "385"], ["Cuba", "cu", "53"], ["Curaçao", "cw", "599", 0], ["Cyprus (Κύπρος)", "cy", "357"], ["Czech Republic (Česká republika)", "cz", "420"], ["Denmark (Danmark)", "dk", "45"], ["Djibouti", "dj", "253"], ["Dominica", "dm", "1", 13, ["767"]], ["Dominican Republic (República Dominicana)", "do", "1", 2, ["809", "829", "849"]], ["Ecuador", "ec", "593"], ["Egypt (‫مصر‬‎)", "eg", "20"], ["El Salvador", "sv", "503"], ["Equatorial Guinea (Guinea Ecuatorial)", "gq", "240"], ["Eritrea", "er", "291"], ["Estonia (Eesti)", "ee", "372"], ["Eswatini", "sz", "268"], ["Ethiopia", "et", "251"], ["Falkland Islands (Islas Malvinas)", "fk", "500"], ["Faroe Islands (Føroyar)", "fo", "298"], ["Fiji", "fj", "679"], ["Finland (Suomi)", "fi", "358", 0], ["France", "fr", "33"], ["French Guiana (Guyane française)", "gf", "594"], ["French Polynesia (Polynésie française)", "pf", "689"], ["Gabon", "ga", "241"], ["Gambia", "gm", "220"], ["Georgia (საქართველო)", "ge", "995"], ["Germany (Deutschland)", "de", "49"], ["Ghana (Gaana)", "gh", "233"], ["Gibraltar", "gi", "350"], ["Greece (Ελλάδα)", "gr", "30"], ["Greenland (Kalaallit Nunaat)", "gl", "299"], ["Grenada", "gd", "1", 14, ["473"]], ["Guadeloupe", "gp", "590", 0], ["Guam", "gu", "1", 15, ["671"]], ["Guatemala", "gt", "502"], ["Guernsey", "gg", "44", 1, ["1481", "7781", "7839", "7911"]], ["Guinea (Guinée)", "gn", "224"], ["Guinea-Bissau (Guiné Bissau)", "gw", "245"], ["Guyana", "gy", "592"], ["Haiti", "ht", "509"], ["Honduras", "hn", "504"], ["Hong Kong (香港)", "hk", "852"], ["Hungary (Magyarország)", "hu", "36"], ["Iceland (Ísland)", "is", "354"], ["India (भारत)", "in", "91"], ["Indonesia", "id", "62"], ["Iran (‫ایران‬‎)", "ir", "98"], ["Iraq (‫العراق‬‎)", "iq", "964"], ["Ireland", "ie", "353"], ["Isle of Man", "im", "44", 2, ["1624", "74576", "7524", "7924", "7624"]], ["Israel (‫ישראל‬‎)", "il", "972"], ["Italy (Italia)", "it", "39", 0], ["Jamaica", "jm", "1", 4, ["876", "658"]], ["Japan (日本)", "jp", "81"], ["Jersey", "je", "44", 3, ["1534", "7509", "7700", "7797", "7829", "7937"]], ["Jordan (‫الأردن‬‎)", "jo", "962"], ["Kazakhstan (Казахстан)", "kz", "7", 1, ["33", "7"]], ["Kenya", "ke", "254"], ["Kiribati", "ki", "686"], ["Kosovo", "xk", "383"], ["Kuwait (‫الكويت‬‎)", "kw", "965"], ["Kyrgyzstan (Кыргызстан)", "kg", "996"], ["Laos (ລາວ)", "la", "856"], ["Latvia (Latvija)", "lv", "371"], ["Lebanon (‫لبنان‬‎)", "lb", "961"], ["Lesotho", "ls", "266"], ["Liberia", "lr", "231"], ["Libya (‫ليبيا‬‎)", "ly", "218"], ["Liechtenstein", "li", "423"], ["Lithuania (Lietuva)", "lt", "370"], ["Luxembourg", "lu", "352"], ["Macau (澳門)", "mo", "853"], ["Madagascar (Madagasikara)", "mg", "261"], ["Malawi", "mw", "265"], ["Malaysia", "my", "60"], ["Maldives", "mv", "960"], ["Mali", "ml", "223"], ["Malta", "mt", "356"], ["Marshall Islands", "mh", "692"], ["Martinique", "mq", "596"], ["Mauritania (‫موريتانيا‬‎)", "mr", "222"], ["Mauritius (Moris)", "mu", "230"], ["Mayotte", "yt", "262", 1, ["269", "639"]], ["Mexico (México)", "mx", "52"], ["Micronesia", "fm", "691"], ["Moldova (Republica Moldova)", "md", "373"], ["Monaco", "mc", "377"], ["Mongolia (Монгол)", "mn", "976"], ["Montenegro (Crna Gora)", "me", "382"], ["Montserrat", "ms", "1", 16, ["664"]], ["Morocco (‫المغرب‬‎)", "ma", "212", 0], ["Mozambique (Moçambique)", "mz", "258"], ["Myanmar (Burma) (မြန်မာ)", "mm", "95"], ["Namibia (Namibië)", "na", "264"], ["Nauru", "nr", "674"], ["Nepal (नेपाल)", "np", "977"], ["Netherlands (Nederland)", "nl", "31"], ["New Caledonia (Nouvelle-Calédonie)", "nc", "687"], ["New Zealand", "nz", "64"], ["Nicaragua", "ni", "505"], ["Niger (Nijar)", "ne", "227"], ["Nigeria", "ng", "234"], ["Niue", "nu", "683"], ["Norfolk Island", "nf", "672"], ["North Korea (조선 민주주의 인민 공화국)", "kp", "850"], ["North Macedonia (Северна Македонија)", "mk", "389"], ["Northern Mariana Islands", "mp", "1", 17, ["670"]], ["Norway (Norge)", "no", "47", 0], ["Oman (‫عُمان‬‎)", "om", "968"], ["Pakistan (‫پاکستان‬‎)", "pk", "92"], ["Palau", "pw", "680"], ["Palestine (‫فلسطين‬‎)", "ps", "970"], ["Panama (Panamá)", "pa", "507"], ["Papua New Guinea", "pg", "675"], ["Paraguay", "py", "595"], ["Peru (Perú)", "pe", "51"], ["Philippines", "ph", "63"], ["Poland (Polska)", "pl", "48"], ["Portugal", "pt", "351"], ["Puerto Rico", "pr", "1", 3, ["787", "939"]], ["Qatar (‫قطر‬‎)", "qa", "974"], ["Réunion (La Réunion)", "re", "262", 0], ["Romania (România)", "ro", "40"], ["Russia (Россия)", "ru", "7", 0], ["Rwanda", "rw", "250"], ["Saint Barthélemy", "bl", "590", 1], ["Saint Helena", "sh", "290"], ["Saint Kitts and Nevis", "kn", "1", 18, ["869"]], ["Saint Lucia", "lc", "1", 19, ["758"]], ["Saint Martin (Saint-Martin (partie française))", "mf", "590", 2], ["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508"], ["Saint Vincent and the Grenadines", "vc", "1", 20, ["784"]], ["Samoa", "ws", "685"], ["San Marino", "sm", "378"], ["São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239"], ["Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966"], ["Senegal (Sénégal)", "sn", "221"], ["Serbia (Србија)", "rs", "381"], ["Seychelles", "sc", "248"], ["Sierra Leone", "sl", "232"], ["Singapore", "sg", "65"], ["Sint Maarten", "sx", "1", 21, ["721"]], ["Slovakia (Slovensko)", "sk", "421"], ["Slovenia (Slovenija)", "si", "386"], ["Solomon Islands", "sb", "677"], ["Somalia (Soomaaliya)", "so", "252"], ["South Africa", "za", "27"], ["South Korea (대한민국)", "kr", "82"], ["South Sudan (‫جنوب السودان‬‎)", "ss", "211"], ["Spain (España)", "es", "34"], ["Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94"], ["Sudan (‫السودان‬‎)", "sd", "249"], ["Suriname", "sr", "597"], ["Svalbard and Jan Mayen", "sj", "47", 1, ["79"]], ["Sweden (Sverige)", "se", "46"], ["Switzerland (Schweiz)", "ch", "41"], ["Syria (‫سوريا‬‎)", "sy", "963"], ["Taiwan (台灣)", "tw", "886"], ["Tajikistan", "tj", "992"], ["Tanzania", "tz", "255"], ["Thailand (ไทย)", "th", "66"], ["Timor-Leste", "tl", "670"], ["Togo", "tg", "228"], ["Tokelau", "tk", "690"], ["Tonga", "to", "676"], ["Trinidad and Tobago", "tt", "1", 22, ["868"]], ["Tunisia (‫تونس‬‎)", "tn", "216"], ["Turkey (Türkiye)", "tr", "90"], ["Turkmenistan", "tm", "993"], ["Turks and Caicos Islands", "tc", "1", 23, ["649"]], ["Tuvalu", "tv", "688"], ["U.S. Virgin Islands", "vi", "1", 24, ["340"]], ["Uganda", "ug", "256"], ["Ukraine (Україна)", "ua", "380"], ["United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971"], ["United Kingdom", "gb", "44", 0], ["United States", "us", "1", 0], ["Uruguay", "uy", "598"], ["Uzbekistan (Oʻzbekiston)", "uz", "998"], ["Vanuatu", "vu", "678"], ["Vatican City (Città del Vaticano)", "va", "39", 1, ["06698"]], ["Venezuela", "ve", "58"], ["Vietnam (Việt Nam)", "vn", "84"], ["Wallis and Futuna (Wallis-et-Futuna)", "wf", "681"], ["Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1, ["5288", "5289"]], ["Yemen (‫اليمن‬‎)", "ye", "967"], ["Zambia", "zm", "260"], ["Zimbabwe", "zw", "263"], ["Åland Islands", "ax", "358", 1, ["18"]]], s = 0; s < a.length; s++) {
        var h = a[s];
        a[s] = {
          name: h[0],
          iso2: h[1],
          dialCode: h[2],
          priority: h[3] || 0,
          areaCodes: h[4] || null
        };
      }
      function g(f) {
        for (var l = 1; l < arguments.length; l++) {
          var t = arguments[l] != null ? Object(arguments[l]) : {}, o = Object.keys(t);
          typeof Object.getOwnPropertySymbols == "function" && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function(u) {
            return Object.getOwnPropertyDescriptor(t, u).enumerable;
          })), o.forEach(function(u) {
            m(f, u, t[u]);
          });
        }
        return f;
      }
      function m(f, l, t) {
        return l = S(l), l in f ? Object.defineProperty(f, l, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : f[l] = t, f;
      }
      function v(f, l) {
        if (!(f instanceof l))
          throw new TypeError("Cannot call a class as a function");
      }
      function w(f, l) {
        for (var t = 0; t < l.length; t++) {
          var o = l[t];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(f, S(o.key), o);
        }
      }
      function R(f, l, t) {
        return l && w(f.prototype, l), t && w(f, t), Object.defineProperty(f, "prototype", {
          writable: !1
        }), f;
      }
      function S(f) {
        var l = O(f, "string");
        return typeof l == "symbol" ? l : String(l);
      }
      function O(f, l) {
        if (typeof f != "object" || f === null)
          return f;
        var t = f[Symbol.toPrimitive];
        if (t !== n) {
          var o = t.call(f, l || "default");
          if (typeof o != "object")
            return o;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (l === "string" ? String : Number)(f);
      }
      var C = {
        getInstance: function(l) {
          var t = l.getAttribute("data-intl-tel-input-id");
          return window.intlTelInputGlobals.instances[t];
        },
        instances: {},
        // using a global like this allows us to mock it in the tests
        documentReady: function() {
          return document.readyState === "complete";
        }
      };
      typeof window == "object" && (window.intlTelInputGlobals = C);
      var D = 0, H = {
        // whether or not to allow the dropdown
        allowDropdown: !0,
        // auto insert dial code (A) on init, (B) on user selecting a country, (C) on calling setCountry
        // also listen for blur/submit and auto remove dial code if that's all there is
        autoInsertDialCode: !1,
        // add a placeholder in the input with an example number for the selected country
        autoPlaceholder: "polite",
        // modify the parentClass
        customContainer: "",
        // modify the auto placeholder
        customPlaceholder: null,
        // append menu to specified element
        dropdownContainer: null,
        // don't display these countries
        excludeCountries: [],
        // format the input value during initialisation and on setNumber
        formatOnDisplay: !0,
        // geoIp lookup function
        geoIpLookup: null,
        // inject a hidden input with this name, and on submit, populate it with the result of getNumber
        hiddenInput: "",
        // initial country
        initialCountry: "",
        // localized country names e.g. { 'de': 'Deutschland' }
        localizedCountries: null,
        // national vs international formatting for numbers e.g. placeholders and displaying existing numbers
        nationalMode: !0,
        // display only these countries
        onlyCountries: [],
        // number type to use for placeholders
        placeholderNumberType: "MOBILE",
        // the countries at the top of the list. defaults to united states and united kingdom
        preferredCountries: ["us", "gb"],
        // display the country dial code next to the selected flag
        separateDialCode: !1,
        // option to hide the flags - must be used with separateDialCode, or allowDropdown=false
        showFlags: !0,
        // specify the path to the libphonenumber script to enable validation/formatting
        utilsScript: ""
      }, W = ["800", "822", "833", "844", "855", "866", "877", "880", "881", "882", "883", "884", "885", "886", "887", "888", "889"], N = function(l, t) {
        for (var o = Object.keys(l), u = 0; u < o.length; u++)
          t(o[u], l[o[u]]);
      }, z = function(l) {
        N(window.intlTelInputGlobals.instances, function(t) {
          window.intlTelInputGlobals.instances[t][l]();
        });
      }, Z = /* @__PURE__ */ function() {
        function f(l, t) {
          var o = this;
          v(this, f), this.id = D++, this.telInput = l, this.activeItem = null, this.highlightedItem = null;
          var u = t || {};
          this.options = {}, N(H, function(y, E) {
            o.options[y] = u.hasOwnProperty(y) ? u[y] : E;
          }), this.hadInitialPlaceholder = !!l.getAttribute("placeholder");
        }
        return R(f, [{
          key: "_init",
          value: function() {
            var t = this;
            this.options.nationalMode && (this.options.autoInsertDialCode = !1), this.options.separateDialCode && (this.options.autoInsertDialCode = !1);
            var o = this.options.allowDropdown && !this.options.separateDialCode;
            if (!this.options.showFlags && o && (this.options.showFlags = !0), this.isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), this.isMobile && (document.body.classList.add("iti-mobile"), this.options.dropdownContainer || (this.options.dropdownContainer = document.body)), this.isRTL = !!this.telInput.closest("[dir=rtl]"), typeof Promise < "u") {
              var u = new Promise(function(E, P) {
                t.resolveAutoCountryPromise = E, t.rejectAutoCountryPromise = P;
              }), y = new Promise(function(E, P) {
                t.resolveUtilsScriptPromise = E, t.rejectUtilsScriptPromise = P;
              });
              this.promise = Promise.all([u, y]);
            } else
              this.resolveAutoCountryPromise = this.rejectAutoCountryPromise = function() {
              }, this.resolveUtilsScriptPromise = this.rejectUtilsScriptPromise = function() {
              };
            this.selectedCountryData = {}, this._processCountryData(), this._generateMarkup(), this._setInitialState(), this._initListeners(), this._initRequests();
          }
        }, {
          key: "_processCountryData",
          value: function() {
            this._processAllCountries(), this._processCountryCodes(), this._processPreferredCountries(), this.options.localizedCountries && this._translateCountriesByLocale(), (this.options.onlyCountries.length || this.options.localizedCountries) && this.countries.sort(this._countryNameSort);
          }
        }, {
          key: "_addCountryCode",
          value: function(t, o, u) {
            o.length > this.countryCodeMaxLen && (this.countryCodeMaxLen = o.length), this.countryCodes.hasOwnProperty(o) || (this.countryCodes[o] = []);
            for (var y = 0; y < this.countryCodes[o].length; y++)
              if (this.countryCodes[o][y] === t)
                return;
            var E = u !== n ? u : this.countryCodes[o].length;
            this.countryCodes[o][E] = t;
          }
        }, {
          key: "_processAllCountries",
          value: function() {
            if (this.options.onlyCountries.length) {
              var t = this.options.onlyCountries.map(function(u) {
                return u.toLowerCase();
              });
              this.countries = a.filter(function(u) {
                return t.indexOf(u.iso2) > -1;
              });
            } else if (this.options.excludeCountries.length) {
              var o = this.options.excludeCountries.map(function(u) {
                return u.toLowerCase();
              });
              this.countries = a.filter(function(u) {
                return o.indexOf(u.iso2) === -1;
              });
            } else
              this.countries = a;
          }
        }, {
          key: "_translateCountriesByLocale",
          value: function() {
            for (var t = 0; t < this.countries.length; t++) {
              var o = this.countries[t].iso2.toLowerCase();
              this.options.localizedCountries.hasOwnProperty(o) && (this.countries[t].name = this.options.localizedCountries[o]);
            }
          }
        }, {
          key: "_countryNameSort",
          value: function(t, o) {
            return t.name < o.name ? -1 : t.name > o.name ? 1 : 0;
          }
        }, {
          key: "_processCountryCodes",
          value: function() {
            this.countryCodeMaxLen = 0, this.dialCodes = {}, this.countryCodes = {};
            for (var t = 0; t < this.countries.length; t++) {
              var o = this.countries[t];
              this.dialCodes[o.dialCode] || (this.dialCodes[o.dialCode] = !0), this._addCountryCode(o.iso2, o.dialCode, o.priority);
            }
            for (var u = 0; u < this.countries.length; u++) {
              var y = this.countries[u];
              if (y.areaCodes)
                for (var E = this.countryCodes[y.dialCode][0], P = 0; P < y.areaCodes.length; P++) {
                  for (var F = y.areaCodes[P], x = 1; x < F.length; x++) {
                    var $ = y.dialCode + F.substr(0, x);
                    this._addCountryCode(E, $), this._addCountryCode(y.iso2, $);
                  }
                  this._addCountryCode(y.iso2, y.dialCode + F);
                }
            }
          }
        }, {
          key: "_processPreferredCountries",
          value: function() {
            this.preferredCountries = [];
            for (var t = 0; t < this.options.preferredCountries.length; t++) {
              var o = this.options.preferredCountries[t].toLowerCase(), u = this._getCountryData(o, !1, !0);
              u && this.preferredCountries.push(u);
            }
          }
        }, {
          key: "_createEl",
          value: function(t, o, u) {
            var y = document.createElement(t);
            return o && N(o, function(E, P) {
              return y.setAttribute(E, P);
            }), u && u.appendChild(y), y;
          }
        }, {
          key: "_generateMarkup",
          value: function() {
            !this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete")) && this.telInput.setAttribute("autocomplete", "off");
            var t = this.options, o = t.allowDropdown, u = t.separateDialCode, y = t.showFlags, E = t.customContainer, P = t.hiddenInput, F = t.dropdownContainer, x = "iti";
            o && (x += " iti--allow-dropdown"), u && (x += " iti--separate-dial-code"), y && (x += " iti--show-flags"), E && (x += " ".concat(E));
            var $ = this._createEl("div", {
              class: x
            });
            this.telInput.parentNode.insertBefore($, this.telInput);
            var V = o || y || u;
            if (V && (this.flagsContainer = this._createEl("div", {
              class: "iti__flag-container"
            }, $)), $.appendChild(this.telInput), V && (this.selectedFlag = this._createEl("div", g({
              class: "iti__selected-flag"
            }, o && {
              role: "combobox",
              "aria-haspopup": "listbox",
              "aria-controls": "iti-".concat(this.id, "__country-listbox"),
              "aria-expanded": "false",
              "aria-label": "Telephone country code"
            }), this.flagsContainer)), y && (this.selectedFlagInner = this._createEl("div", {
              class: "iti__flag"
            }, this.selectedFlag)), this.selectedFlag && this.telInput.disabled && this.selectedFlag.setAttribute("aria-disabled", "true"), u && (this.selectedDialCode = this._createEl("div", {
              class: "iti__selected-dial-code"
            }, this.selectedFlag)), o && (this.telInput.disabled || this.selectedFlag.setAttribute("tabindex", "0"), this.dropdownArrow = this._createEl("div", {
              class: "iti__arrow"
            }, this.selectedFlag), this.countryList = this._createEl("ul", {
              class: "iti__country-list iti__hide",
              id: "iti-".concat(this.id, "__country-listbox"),
              role: "listbox",
              "aria-label": "List of countries"
            }), this.preferredCountries.length && (this._appendListItems(this.preferredCountries, "iti__preferred", !0), this._createEl("li", {
              class: "iti__divider",
              role: "separator",
              "aria-disabled": "true"
            }, this.countryList)), this._appendListItems(this.countries, "iti__standard"), F ? (this.dropdown = this._createEl("div", {
              class: "iti iti--container"
            }), this.dropdown.appendChild(this.countryList)) : this.flagsContainer.appendChild(this.countryList)), P) {
              var re = P, _ = this.telInput.getAttribute("name");
              if (_) {
                var A = _.lastIndexOf("[");
                A !== -1 && (re = "".concat(_.substr(0, A), "[").concat(re, "]"));
              }
              this.hiddenInput = this._createEl("input", {
                type: "hidden",
                name: re
              }), $.appendChild(this.hiddenInput);
            }
          }
        }, {
          key: "_appendListItems",
          value: function(t, o, u) {
            for (var y = "", E = 0; E < t.length; E++) {
              var P = t[E], F = u ? "-preferred" : "";
              y += "<li class='iti__country ".concat(o, "' tabIndex='-1' id='iti-").concat(this.id, "__item-").concat(P.iso2).concat(F, "' role='option' data-dial-code='").concat(P.dialCode, "' data-country-code='").concat(P.iso2, "' aria-selected='false'>"), this.options.showFlags && (y += "<div class='iti__flag-box'><div class='iti__flag iti__".concat(P.iso2, "'></div></div>")), y += "<span class='iti__country-name'>".concat(P.name, "</span>"), y += "<span class='iti__dial-code'>+".concat(P.dialCode, "</span>"), y += "</li>";
            }
            this.countryList.insertAdjacentHTML("beforeend", y);
          }
        }, {
          key: "_setInitialState",
          value: function() {
            var t = this.telInput.getAttribute("value"), o = this.telInput.value, u = t && t.charAt(0) === "+" && (!o || o.charAt(0) !== "+"), y = u ? t : o, E = this._getDialCode(y), P = this._isRegionlessNanp(y), F = this.options, x = F.initialCountry, $ = F.autoInsertDialCode;
            E && !P ? this._updateFlagFromNumber(y) : x !== "auto" && (x ? this._setFlag(x.toLowerCase()) : E && P ? this._setFlag("us") : (this.defaultCountry = this.preferredCountries.length ? this.preferredCountries[0].iso2 : this.countries[0].iso2, y || this._setFlag(this.defaultCountry)), !y && $ && (this.telInput.value = "+".concat(this.selectedCountryData.dialCode))), y && this._updateValFromNumber(y);
          }
        }, {
          key: "_initListeners",
          value: function() {
            this._initKeyListeners(), this.options.autoInsertDialCode && this._initBlurListeners(), this.options.allowDropdown && this._initDropdownListeners(), this.hiddenInput && this._initHiddenInputListener();
          }
        }, {
          key: "_initHiddenInputListener",
          value: function() {
            var t = this;
            this._handleHiddenInputSubmit = function() {
              t.hiddenInput.value = t.getNumber();
            }, this.telInput.form && this.telInput.form.addEventListener("submit", this._handleHiddenInputSubmit);
          }
        }, {
          key: "_getClosestLabel",
          value: function() {
            for (var t = this.telInput; t && t.tagName !== "LABEL"; )
              t = t.parentNode;
            return t;
          }
        }, {
          key: "_initDropdownListeners",
          value: function() {
            var t = this;
            this._handleLabelClick = function(u) {
              t.countryList.classList.contains("iti__hide") ? t.telInput.focus() : u.preventDefault();
            };
            var o = this._getClosestLabel();
            o && o.addEventListener("click", this._handleLabelClick), this._handleClickSelectedFlag = function() {
              t.countryList.classList.contains("iti__hide") && !t.telInput.disabled && !t.telInput.readOnly && t._showDropdown();
            }, this.selectedFlag.addEventListener("click", this._handleClickSelectedFlag), this._handleFlagsContainerKeydown = function(u) {
              var y = t.countryList.classList.contains("iti__hide");
              y && ["ArrowUp", "Up", "ArrowDown", "Down", " ", "Enter"].indexOf(u.key) !== -1 && (u.preventDefault(), u.stopPropagation(), t._showDropdown()), u.key === "Tab" && t._closeDropdown();
            }, this.flagsContainer.addEventListener("keydown", this._handleFlagsContainerKeydown);
          }
        }, {
          key: "_initRequests",
          value: function() {
            var t = this;
            this.options.utilsScript && !window.intlTelInputUtils ? window.intlTelInputGlobals.documentReady() ? window.intlTelInputGlobals.loadUtils(this.options.utilsScript) : window.addEventListener("load", function() {
              window.intlTelInputGlobals.loadUtils(t.options.utilsScript);
            }) : this.resolveUtilsScriptPromise(), this.options.initialCountry === "auto" ? this._loadAutoCountry() : this.resolveAutoCountryPromise();
          }
        }, {
          key: "_loadAutoCountry",
          value: function() {
            window.intlTelInputGlobals.autoCountry ? this.handleAutoCountry() : window.intlTelInputGlobals.startedLoadingAutoCountry || (window.intlTelInputGlobals.startedLoadingAutoCountry = !0, typeof this.options.geoIpLookup == "function" && this.options.geoIpLookup(function(t) {
              window.intlTelInputGlobals.autoCountry = t.toLowerCase(), setTimeout(function() {
                return z("handleAutoCountry");
              });
            }, function() {
              return z("rejectAutoCountryPromise");
            }));
          }
        }, {
          key: "_initKeyListeners",
          value: function() {
            var t = this;
            this._handleKeyupEvent = function() {
              t._updateFlagFromNumber(t.telInput.value) && t._triggerCountryChange();
            }, this.telInput.addEventListener("keyup", this._handleKeyupEvent), this._handleClipboardEvent = function() {
              setTimeout(t._handleKeyupEvent);
            }, this.telInput.addEventListener("cut", this._handleClipboardEvent), this.telInput.addEventListener("paste", this._handleClipboardEvent);
          }
        }, {
          key: "_cap",
          value: function(t) {
            var o = this.telInput.getAttribute("maxlength");
            return o && t.length > o ? t.substr(0, o) : t;
          }
        }, {
          key: "_initBlurListeners",
          value: function() {
            var t = this;
            this._handleSubmitOrBlurEvent = function() {
              t._removeEmptyDialCode();
            }, this.telInput.form && this.telInput.form.addEventListener("submit", this._handleSubmitOrBlurEvent), this.telInput.addEventListener("blur", this._handleSubmitOrBlurEvent);
          }
        }, {
          key: "_removeEmptyDialCode",
          value: function() {
            if (this.telInput.value.charAt(0) === "+") {
              var t = this._getNumeric(this.telInput.value);
              (!t || this.selectedCountryData.dialCode === t) && (this.telInput.value = "");
            }
          }
        }, {
          key: "_getNumeric",
          value: function(t) {
            return t.replace(/\D/g, "");
          }
        }, {
          key: "_trigger",
          value: function(t) {
            var o = document.createEvent("Event");
            o.initEvent(t, !0, !0), this.telInput.dispatchEvent(o);
          }
        }, {
          key: "_showDropdown",
          value: function() {
            this.countryList.classList.remove("iti__hide"), this.selectedFlag.setAttribute("aria-expanded", "true"), this._setDropdownPosition(), this.activeItem && (this._highlightListItem(this.activeItem, !1), this._scrollTo(this.activeItem, !0)), this._bindDropdownListeners(), this.dropdownArrow.classList.add("iti__arrow--up"), this._trigger("open:countrydropdown");
          }
        }, {
          key: "_toggleClass",
          value: function(t, o, u) {
            u && !t.classList.contains(o) ? t.classList.add(o) : !u && t.classList.contains(o) && t.classList.remove(o);
          }
        }, {
          key: "_setDropdownPosition",
          value: function() {
            var t = this;
            if (this.options.dropdownContainer && this.options.dropdownContainer.appendChild(this.dropdown), !this.isMobile) {
              var o = this.telInput.getBoundingClientRect(), u = window.pageYOffset || document.documentElement.scrollTop, y = o.top + u, E = this.countryList.offsetHeight, P = y + this.telInput.offsetHeight + E < u + window.innerHeight, F = y - E > u;
              if (this._toggleClass(this.countryList, "iti__country-list--dropup", !P && F), this.options.dropdownContainer) {
                var x = !P && F ? 0 : this.telInput.offsetHeight;
                this.dropdown.style.top = "".concat(y + x, "px"), this.dropdown.style.left = "".concat(o.left + document.body.scrollLeft, "px"), this._handleWindowScroll = function() {
                  return t._closeDropdown();
                }, window.addEventListener("scroll", this._handleWindowScroll);
              }
            }
          }
        }, {
          key: "_getClosestListItem",
          value: function(t) {
            for (var o = t; o && o !== this.countryList && !o.classList.contains("iti__country"); )
              o = o.parentNode;
            return o === this.countryList ? null : o;
          }
        }, {
          key: "_bindDropdownListeners",
          value: function() {
            var t = this;
            this._handleMouseoverCountryList = function(E) {
              var P = t._getClosestListItem(E.target);
              P && t._highlightListItem(P, !1);
            }, this.countryList.addEventListener("mouseover", this._handleMouseoverCountryList), this._handleClickCountryList = function(E) {
              var P = t._getClosestListItem(E.target);
              P && t._selectListItem(P);
            }, this.countryList.addEventListener("click", this._handleClickCountryList);
            var o = !0;
            this._handleClickOffToClose = function() {
              o || t._closeDropdown(), o = !1;
            }, document.documentElement.addEventListener("click", this._handleClickOffToClose);
            var u = "", y = null;
            this._handleKeydownOnDropdown = function(E) {
              E.preventDefault(), E.key === "ArrowUp" || E.key === "Up" || E.key === "ArrowDown" || E.key === "Down" ? t._handleUpDownKey(E.key) : E.key === "Enter" ? t._handleEnterKey() : E.key === "Escape" ? t._closeDropdown() : /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(E.key) && (y && clearTimeout(y), u += E.key.toLowerCase(), t._searchForCountry(u), y = setTimeout(function() {
                u = "";
              }, 1e3));
            }, document.addEventListener("keydown", this._handleKeydownOnDropdown);
          }
        }, {
          key: "_handleUpDownKey",
          value: function(t) {
            var o = t === "ArrowUp" || t === "Up" ? this.highlightedItem.previousElementSibling : this.highlightedItem.nextElementSibling;
            o && (o.classList.contains("iti__divider") && (o = t === "ArrowUp" || t === "Up" ? o.previousElementSibling : o.nextElementSibling), this._highlightListItem(o, !0));
          }
        }, {
          key: "_handleEnterKey",
          value: function() {
            this.highlightedItem && this._selectListItem(this.highlightedItem);
          }
        }, {
          key: "_searchForCountry",
          value: function(t) {
            for (var o = 0; o < this.countries.length; o++)
              if (this._startsWith(this.countries[o].name, t)) {
                var u = this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(this.countries[o].iso2));
                this._highlightListItem(u, !1), this._scrollTo(u, !0);
                break;
              }
          }
        }, {
          key: "_startsWith",
          value: function(t, o) {
            return t.substr(0, o.length).toLowerCase() === o;
          }
        }, {
          key: "_updateValFromNumber",
          value: function(t) {
            var o = t;
            if (this.options.formatOnDisplay && window.intlTelInputUtils && this.selectedCountryData) {
              var u = this.options.nationalMode || o.charAt(0) !== "+" && !this.options.separateDialCode, y = intlTelInputUtils.numberFormat, E = y.NATIONAL, P = y.INTERNATIONAL, F = u ? E : P;
              o = intlTelInputUtils.formatNumber(o, this.selectedCountryData.iso2, F);
            }
            o = this._beforeSetNumber(o), this.telInput.value = o;
          }
        }, {
          key: "_updateFlagFromNumber",
          value: function(t) {
            var o = t, u = this.selectedCountryData.dialCode, y = u === "1";
            o && y && o.charAt(0) !== "+" && (o.charAt(0) !== "1" && (o = "1".concat(o)), o = "+".concat(o)), this.options.separateDialCode && u && o.charAt(0) !== "+" && (o = "+".concat(u).concat(o));
            var E = this._getDialCode(o, !0), P = this._getNumeric(o), F = null;
            if (E) {
              var x = this.countryCodes[this._getNumeric(E)], $ = x.indexOf(this.selectedCountryData.iso2) !== -1 && P.length <= E.length - 1, V = u === "1" && this._isRegionlessNanp(P);
              if (!V && !$) {
                for (var re = 0; re < x.length; re++)
                  if (x[re]) {
                    F = x[re];
                    break;
                  }
              }
            } else
              o.charAt(0) === "+" && P.length ? F = "" : (!o || o === "+") && (F = this.defaultCountry);
            return F !== null ? this._setFlag(F) : !1;
          }
        }, {
          key: "_isRegionlessNanp",
          value: function(t) {
            var o = this._getNumeric(t);
            if (o.charAt(0) === "1") {
              var u = o.substr(1, 3);
              return W.indexOf(u) !== -1;
            }
            return !1;
          }
        }, {
          key: "_highlightListItem",
          value: function(t, o) {
            var u = this.highlightedItem;
            u && u.classList.remove("iti__highlight"), this.highlightedItem = t, this.highlightedItem.classList.add("iti__highlight"), this.selectedFlag.setAttribute("aria-activedescendant", t.getAttribute("id")), o && this.highlightedItem.focus();
          }
        }, {
          key: "_getCountryData",
          value: function(t, o, u) {
            for (var y = o ? a : this.countries, E = 0; E < y.length; E++)
              if (y[E].iso2 === t)
                return y[E];
            if (u)
              return null;
            throw new Error("No country data for '".concat(t, "'"));
          }
        }, {
          key: "_setFlag",
          value: function(t) {
            var o = this.options, u = o.allowDropdown, y = o.separateDialCode, E = o.showFlags, P = this.selectedCountryData.iso2 ? this.selectedCountryData : {};
            if (this.selectedCountryData = t ? this._getCountryData(t, !1, !1) : {}, this.selectedCountryData.iso2 && (this.defaultCountry = this.selectedCountryData.iso2), E && this.selectedFlagInner.setAttribute("class", "iti__flag iti__".concat(t)), this._setSelectedCountryFlagTitleAttribute(t, y), y) {
              var F = this.selectedCountryData.dialCode ? "+".concat(this.selectedCountryData.dialCode) : "";
              this.selectedDialCode.innerHTML = F;
              var x = this.selectedFlag.offsetWidth || this._getHiddenSelectedFlagWidth();
              this.isRTL ? this.telInput.style.paddingRight = "".concat(x + 6, "px") : this.telInput.style.paddingLeft = "".concat(x + 6, "px");
            }
            if (this._updatePlaceholder(), u) {
              var $ = this.activeItem;
              if ($ && ($.classList.remove("iti__active"), $.setAttribute("aria-selected", "false")), t) {
                var V = this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(t, "-preferred")) || this.countryList.querySelector("#iti-".concat(this.id, "__item-").concat(t));
                V.setAttribute("aria-selected", "true"), V.classList.add("iti__active"), this.activeItem = V;
              }
            }
            return P.iso2 !== t;
          }
        }, {
          key: "_setSelectedCountryFlagTitleAttribute",
          value: function(t, o) {
            if (this.selectedFlag) {
              var u;
              t && !o ? u = "".concat(this.selectedCountryData.name, ": +").concat(this.selectedCountryData.dialCode) : t ? u = this.selectedCountryData.name : u = "Unknown", this.selectedFlag.setAttribute("title", u);
            }
          }
        }, {
          key: "_getHiddenSelectedFlagWidth",
          value: function() {
            var t = this.telInput.parentNode.cloneNode();
            t.style.visibility = "hidden", document.body.appendChild(t);
            var o = this.flagsContainer.cloneNode();
            t.appendChild(o);
            var u = this.selectedFlag.cloneNode(!0);
            o.appendChild(u);
            var y = u.offsetWidth;
            return t.parentNode.removeChild(t), y;
          }
        }, {
          key: "_updatePlaceholder",
          value: function() {
            var t = this.options.autoPlaceholder === "aggressive" || !this.hadInitialPlaceholder && this.options.autoPlaceholder === "polite";
            if (window.intlTelInputUtils && t) {
              var o = intlTelInputUtils.numberType[this.options.placeholderNumberType], u = this.selectedCountryData.iso2 ? intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, this.options.nationalMode, o) : "";
              u = this._beforeSetNumber(u), typeof this.options.customPlaceholder == "function" && (u = this.options.customPlaceholder(u, this.selectedCountryData)), this.telInput.setAttribute("placeholder", u);
            }
          }
        }, {
          key: "_selectListItem",
          value: function(t) {
            var o = this._setFlag(t.getAttribute("data-country-code"));
            this._closeDropdown(), this._updateDialCode(t.getAttribute("data-dial-code")), this.telInput.focus();
            var u = this.telInput.value.length;
            this.telInput.setSelectionRange(u, u), o && this._triggerCountryChange();
          }
        }, {
          key: "_closeDropdown",
          value: function() {
            this.countryList.classList.add("iti__hide"), this.selectedFlag.setAttribute("aria-expanded", "false"), this.selectedFlag.removeAttribute("aria-activedescendant"), this.dropdownArrow.classList.remove("iti__arrow--up"), document.removeEventListener("keydown", this._handleKeydownOnDropdown), document.documentElement.removeEventListener("click", this._handleClickOffToClose), this.countryList.removeEventListener("mouseover", this._handleMouseoverCountryList), this.countryList.removeEventListener("click", this._handleClickCountryList), this.options.dropdownContainer && (this.isMobile || window.removeEventListener("scroll", this._handleWindowScroll), this.dropdown.parentNode && this.dropdown.parentNode.removeChild(this.dropdown)), this._trigger("close:countrydropdown");
          }
        }, {
          key: "_scrollTo",
          value: function(t, o) {
            var u = this.countryList, y = window.pageYOffset || document.documentElement.scrollTop, E = u.offsetHeight, P = u.getBoundingClientRect().top + y, F = P + E, x = t.offsetHeight, $ = t.getBoundingClientRect().top + y, V = $ + x, re = $ - P + u.scrollTop, _ = E / 2 - x / 2;
            if ($ < P)
              o && (re -= _), u.scrollTop = re;
            else if (V > F) {
              o && (re += _);
              var A = E - x;
              u.scrollTop = re - A;
            }
          }
        }, {
          key: "_updateDialCode",
          value: function(t) {
            var o = this.telInput.value, u = "+".concat(t), y;
            if (o.charAt(0) === "+") {
              var E = this._getDialCode(o);
              E ? y = o.replace(E, u) : y = u, this.telInput.value = y;
            } else
              this.options.autoInsertDialCode && (o ? y = u + o : y = u, this.telInput.value = y);
          }
        }, {
          key: "_getDialCode",
          value: function(t, o) {
            var u = "";
            if (t.charAt(0) === "+")
              for (var y = "", E = 0; E < t.length; E++) {
                var P = t.charAt(E);
                if (!isNaN(parseInt(P, 10))) {
                  if (y += P, o)
                    this.countryCodes[y] && (u = t.substr(0, E + 1));
                  else if (this.dialCodes[y]) {
                    u = t.substr(0, E + 1);
                    break;
                  }
                  if (y.length === this.countryCodeMaxLen)
                    break;
                }
              }
            return u;
          }
        }, {
          key: "_getFullNumber",
          value: function() {
            var t = this.telInput.value.trim(), o = this.selectedCountryData.dialCode, u, y = this._getNumeric(t);
            return this.options.separateDialCode && t.charAt(0) !== "+" && o && y ? u = "+".concat(o) : u = "", u + t;
          }
        }, {
          key: "_beforeSetNumber",
          value: function(t) {
            var o = t;
            if (this.options.separateDialCode) {
              var u = this._getDialCode(o);
              if (u) {
                u = "+".concat(this.selectedCountryData.dialCode);
                var y = o[u.length] === " " || o[u.length] === "-" ? u.length + 1 : u.length;
                o = o.substr(y);
              }
            }
            return this._cap(o);
          }
        }, {
          key: "_triggerCountryChange",
          value: function() {
            this._trigger("countrychange");
          }
        }, {
          key: "handleAutoCountry",
          value: function() {
            this.options.initialCountry === "auto" && (this.defaultCountry = window.intlTelInputGlobals.autoCountry, this.telInput.value || this.setCountry(this.defaultCountry), this.resolveAutoCountryPromise());
          }
        }, {
          key: "handleUtils",
          value: function() {
            window.intlTelInputUtils && (this.telInput.value && this._updateValFromNumber(this.telInput.value), this._updatePlaceholder()), this.resolveUtilsScriptPromise();
          }
        }, {
          key: "destroy",
          value: function() {
            var t = this.telInput.form;
            if (this.options.allowDropdown) {
              this._closeDropdown(), this.selectedFlag.removeEventListener("click", this._handleClickSelectedFlag), this.flagsContainer.removeEventListener("keydown", this._handleFlagsContainerKeydown);
              var o = this._getClosestLabel();
              o && o.removeEventListener("click", this._handleLabelClick);
            }
            this.hiddenInput && t && t.removeEventListener("submit", this._handleHiddenInputSubmit), this.options.autoInsertDialCode && (t && t.removeEventListener("submit", this._handleSubmitOrBlurEvent), this.telInput.removeEventListener("blur", this._handleSubmitOrBlurEvent)), this.telInput.removeEventListener("keyup", this._handleKeyupEvent), this.telInput.removeEventListener("cut", this._handleClipboardEvent), this.telInput.removeEventListener("paste", this._handleClipboardEvent), this.telInput.removeAttribute("data-intl-tel-input-id");
            var u = this.telInput.parentNode;
            u.parentNode.insertBefore(this.telInput, u), u.parentNode.removeChild(u), delete window.intlTelInputGlobals.instances[this.id];
          }
        }, {
          key: "getExtension",
          value: function() {
            return window.intlTelInputUtils ? intlTelInputUtils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2) : "";
          }
        }, {
          key: "getNumber",
          value: function(t) {
            if (window.intlTelInputUtils) {
              var o = this.selectedCountryData.iso2;
              return intlTelInputUtils.formatNumber(this._getFullNumber(), o, t);
            }
            return "";
          }
        }, {
          key: "getNumberType",
          value: function() {
            return window.intlTelInputUtils ? intlTelInputUtils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2) : -99;
          }
        }, {
          key: "getSelectedCountryData",
          value: function() {
            return this.selectedCountryData;
          }
        }, {
          key: "getValidationError",
          value: function() {
            if (window.intlTelInputUtils) {
              var t = this.selectedCountryData.iso2;
              return intlTelInputUtils.getValidationError(this._getFullNumber(), t);
            }
            return -99;
          }
        }, {
          key: "isValidNumber",
          value: function() {
            var t = this._getFullNumber().trim();
            return window.intlTelInputUtils ? intlTelInputUtils.isValidNumber(t, this.selectedCountryData.iso2) : null;
          }
        }, {
          key: "isPossibleNumber",
          value: function() {
            var t = this._getFullNumber().trim();
            return window.intlTelInputUtils ? intlTelInputUtils.isPossibleNumber(t, this.selectedCountryData.iso2) : null;
          }
        }, {
          key: "setCountry",
          value: function(t) {
            var o = t.toLowerCase();
            this.selectedCountryData.iso2 !== o && (this._setFlag(o), this._updateDialCode(this.selectedCountryData.dialCode), this._triggerCountryChange());
          }
        }, {
          key: "setNumber",
          value: function(t) {
            var o = this._updateFlagFromNumber(t);
            this._updateValFromNumber(t), o && this._triggerCountryChange();
          }
        }, {
          key: "setPlaceholderNumberType",
          value: function(t) {
            this.options.placeholderNumberType = t, this._updatePlaceholder();
          }
        }]), f;
      }();
      C.getCountryData = function() {
        return a;
      };
      var p = function(l, t, o) {
        var u = document.createElement("script");
        u.onload = function() {
          z("handleUtils"), t && t();
        }, u.onerror = function() {
          z("rejectUtilsScriptPromise"), o && o();
        }, u.className = "iti-load-utils", u.async = !0, u.src = l, document.body.appendChild(u);
      };
      return C.loadUtils = function(f) {
        if (!window.intlTelInputUtils && !window.intlTelInputGlobals.startedLoadingUtilsScript) {
          if (window.intlTelInputGlobals.startedLoadingUtilsScript = !0, typeof Promise < "u")
            return new Promise(function(l, t) {
              return p(f, l, t);
            });
          p(f);
        }
        return null;
      }, C.defaults = H, C.version = "18.2.1", function(f, l) {
        var t = new Z(f, l);
        return t._init(), f.setAttribute("data-intl-tel-input-id", t.id), window.intlTelInputGlobals.instances[t.id] = t, t;
      };
    }();
  });
})(intlTelInput$3);
var intlTelInputExports = intlTelInput$3.exports, intlTelInput$1 = intlTelInputExports;
const intlTelInput$2 = /* @__PURE__ */ getDefaultExportFromCjs(intlTelInput$1), intlTelInput = "";
/*! js-cookie v3.0.1 | MIT */
function assign(r) {
  for (var n = 1; n < arguments.length; n++) {
    var a = arguments[n];
    for (var s in a)
      r[s] = a[s];
  }
  return r;
}
var defaultConverter = {
  read: function(r) {
    return r[0] === '"' && (r = r.slice(1, -1)), r.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(r) {
    return encodeURIComponent(r).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function init(r, n) {
  function a(h, g, m) {
    if (!(typeof document > "u")) {
      m = assign({}, n, m), typeof m.expires == "number" && (m.expires = new Date(Date.now() + m.expires * 864e5)), m.expires && (m.expires = m.expires.toUTCString()), h = encodeURIComponent(h).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var v = "";
      for (var w in m)
        m[w] && (v += "; " + w, m[w] !== !0 && (v += "=" + m[w].split(";")[0]));
      return document.cookie = h + "=" + r.write(g, h) + v;
    }
  }
  function s(h) {
    if (!(typeof document > "u" || arguments.length && !h)) {
      for (var g = document.cookie ? document.cookie.split("; ") : [], m = {}, v = 0; v < g.length; v++) {
        var w = g[v].split("="), R = w.slice(1).join("=");
        try {
          var S = decodeURIComponent(w[0]);
          if (m[S] = r.read(R, S), h === S)
            break;
        } catch {
        }
      }
      return h ? m[h] : m;
    }
  }
  return Object.create(
    {
      set: a,
      get: s,
      remove: function(h, g) {
        a(
          h,
          "",
          assign({}, g, {
            expires: -1
          })
        );
      },
      withAttributes: function(h) {
        return init(this.converter, assign({}, this.attributes, h));
      },
      withConverter: function(h) {
        return init(assign({}, this.converter, h), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(n) },
      converter: { value: Object.freeze(r) }
    }
  );
}
var api = init(defaultConverter, { path: "/" });
function updateOrSetQueryStringParam(r, n, a) {
  if (typeof a > "u")
    return r;
  var s = new RegExp("([?&])" + n + "=.*?(&|$)", "i"), h = r.indexOf("?") !== -1 ? "&" : "?";
  return r.match(s) ? r.replace(s, "$1" + n + "=" + a + "$2") : r + h + n + "=" + a;
}
function getUrlVars(r) {
  var n = [], a = r.split("?")[1];
  if (!a)
    return n;
  for (var s = a.split("&"), h = 0; h < s.length; h++) {
    var g = s[h].split("=");
    n.push({ key: g[0], value: g[1] });
  }
  return n;
}
const widgetId = () => {
  var r;
  return (r = window.AXLData) == null ? void 0 : r.widgetId;
}, inIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return !0;
  }
}, isInsideWidget = (r) => (r || (r = widgetId()), r && inIframe()), buildProperHref = (r) => r.startsWith("/") ? document.location.protocol + "//" + document.location.host + r : r, emulateClick = (r, n) => {
  if (r != "") {
    if (isInsideWidget()) {
      window.parent.postMessage({
        type: "emulateClick",
        href: buildProperHref(r),
        target: n,
        from: widgetId()
      }, "*");
      return;
    }
    var a = document.createElement("a");
    document.body.appendChild(a), a.href = r, n && (a.target = n), setTimeout(() => {
      a.click(), a.remove();
    }, 10);
  }
}, injectScript = (r, n = "head", a = !1) => new Promise((s, h) => {
  try {
    const m = n == "head" ? document.getElementsByTagName("head")[0] : document.body;
    var g = document.createElement("script");
    g.type = "text/javascript", g.src = r, g.async = a, g.onerror = (v) => h(v), g.onload = () => s(), m.appendChild(g);
  } catch (m) {
    h(m);
  }
}), makeIframesLazy = () => {
  const r = document.querySelectorAll("iframe");
  if ("IntersectionObserver" in window) {
    const n = new IntersectionObserver((a, s) => {
      a.forEach((h) => {
        if (h.isIntersecting) {
          const g = h.target;
          g.src = g.dataset.src || "", s.unobserve(g);
        }
      });
    }, {
      rootMargin: "100% 0px 0px 0px",
      threshold: 0
    });
    r.forEach((a) => {
      a.dataset.src = a.src, a.src = "", n.observe(a);
    });
  } else
    r.forEach((n) => {
      const a = n;
      a.src = a.dataset.src || "";
    });
}, injectStyle = (r) => new Promise((n, a) => {
  try {
    const h = document.getElementsByTagName("head")[0];
    var s = document.createElement("link");
    s.rel = "stylesheet", s.type = "text/css", s.href = r, s.media = "all", s.onerror = (g) => a(g), s.onload = () => n(), h.appendChild(s);
  } catch (h) {
    a(h);
  }
}), replaceAXLVariables = (r, n, a) => {
  if (!a || a.length == 0)
    return r;
  var s = AXLReplaceTagsRegex.find((h) => h.type == n);
  return s ? (a = a.replace(/[+]/g, "%2B"), r.replace(s.regex, a)) : r;
};
var AXLReplaceTags = /* @__PURE__ */ ((r) => (r[r.Id = 0] = "Id", r[r.FirstName = 1] = "FirstName", r[r.LastName = 2] = "LastName", r[r.Email = 3] = "Email", r[r.Phone = 4] = "Phone", r))(AXLReplaceTags || {});
const AXLReplaceTagsRegex = [
  {
    type: 0,
    regex: new RegExp("[#{]ID[}#]", "g")
  },
  {
    type: 1,
    regex: new RegExp("[#{]FirstName[}#]", "g")
  },
  {
    type: 2,
    regex: new RegExp("[#{]LastName[}#]", "g")
  },
  {
    type: 3,
    regex: new RegExp("[#{]Email[}#]", "g")
  },
  {
    type: 4,
    regex: new RegExp("[#{]Phone[}#]", "g")
  }
];
var AXLWebsiteEventEnum = /* @__PURE__ */ ((r) => (r.CheckoutSuccess = "CheckoutSuccess", r.CheckoutError = "CheckoutFail", r.CheckoutInit = "CheckoutInit", r.CheckoutStarted = "CheckoutStarted", r.FormSubmit = "FormSubmit", r))(AXLWebsiteEventEnum || {});
function ezInitForms(r, n) {
  const a = document.querySelectorAll(".ez-form form, form.ez-form");
  if (!(!a || a.length == 0))
    for (var s = 0; s < a.length; s++)
      new EZForm(a[s], r, n);
}
const CountryCookieName = "ez-country";
class EZForm {
  constructor(n, a, s) {
    var g, m;
    this.form = n, this.formParams = a, this.isAuthorized = s, this.isSubmitting = !1, this.currentCountry = api.get(CountryCookieName) || "us", this.loader = null, this.anyFieldHiddenDueToAuth = !1, this.fieldChangeHandler = (v) => {
      var w = v.currentTarget;
      if (w.touched) {
        var R = this.fieldIsValid(w);
        if (R.isValid)
          this.fieldHideError(w);
        else {
          this.fieldShowError(R);
          return;
        }
        this.fieldKeyUpHandler(v);
      }
    }, this.fieldKeyUpHandler = (v) => {
      var w = v.currentTarget;
      w.nodeName.toUpperCase() != "TEXTAREA" && v instanceof KeyboardEvent && v.key == "Enter" && this.submit();
    }, this.fieldAddEnterKeyListener = (v) => {
      v.nodeName.toUpperCase() != "TEXTAREA" && v.addEventListener("keyup", (w) => {
        w.key == "Enter" && this.submit();
      });
    }, this.fieldIsValid = (v) => {
      var S;
      v.classList.remove("invalid");
      var w = { dom: v, name: v.name, isValid: !0, message: "" };
      if (v.required && v.value.length == 0)
        return { ...w, isValid: !1, message: this.localize.words.required };
      if (v.required && v.getAttribute("type") == "checkbox" && !v.checked)
        return { ...w, isValid: !1, message: this.localize.words.required };
      var R = v.getAttribute("validation");
      if (!R || v.type == "hidden" || !v.required && v.value.length == 0)
        return w;
      switch (R) {
        case "email":
          return v.value = (S = v.value) == null ? void 0 : S.trim(), {
            ...w,
            isValid: isEmail(v.value),
            message: this.localize.words.invalidEmail
          };
        case "phone":
          return {
            ...w,
            //@ts-ignore
            isValid: v.intlTelInput.isValidNumber(),
            message: this.localize.words.invalidPhone
          };
        case "number":
          return {
            ...w,
            isValid: isNumeric(v.value) || _default(v.value),
            message: this.localize.words.invalidNumber
          };
        case "url":
          return {
            ...w,
            isValid: isURL(v.value),
            message: this.localize.words.invalidUrl
          };
      }
    }, this.fieldShowError = (v) => {
      var S;
      if (v.dom.getAttribute("type") == "checkbox" ? (S = v.dom.parentElement) == null || S.classList.add("invalid") : v.dom.classList.add("invalid"), v.message) {
        var w = v.dom.closest(".form-control");
        if (w) {
          v.dom.errorField && v.dom.errorField.remove();
          var R = document.createElement("div");
          R.classList.add("field-error"), R.innerText = v.message || "", w.appendChild(R), v.dom.errorField = R;
        }
      }
    }, this.fieldHideError = (v) => {
      var w = v.closest(".form-control");
      w == null || w.querySelectorAll(".field-error").forEach((R) => R.remove());
    }, this.sendFormCallBack = async ({ status: v, data: w }) => {
      var O, C, D, H;
      if (this.formResponse = w, this.setIsSubmitting(!1), v != 200) {
        var R;
        !w.message && w.errors && w.errors.length > 0 ? R = w.errors.map((W) => W.message).join(`
`) : w.message && (R = w.message), this.showError(R, 3);
        return;
      }
      if (typeof window.fbq < "u") {
        const N = (((O = window.AXLData) == null ? void 0 : O.sitePageId) || ((C = window.AXLData) == null ? void 0 : C.widgetId) || "") + "_" + ((H = (D = this.formResponse) == null ? void 0 : D.body) == null ? void 0 : H.contactId);
        window.fbq("track", "Lead", {}, { eventId: N });
      }
      typeof window._axlOnSuccessFormSubmit == "function" && window._axlOnSuccessFormSubmit(this.formData);
      var S = window.AXLWebsite;
      S && S.dispatch("FormSubmit", this.formData), this.showMessage(this.formMessageToShow), await this.execJS(), this.execRedirect(), this.submitButton && typeof this.submitButton._onSuccessFormSubmit == "function" && this.submitButton._onSuccessFormSubmit(this.submitButton);
    }, this.initSubmit(), this.initFields(), this.hideFieldsIfAuthorized(), this.initButtonSubmit();
    var h = (m = (g = window.AXLData) == null ? void 0 : g.formSettings) == null ? void 0 : m.loc;
    this.localize = new FormLocalization(h);
  }
  get fields() {
    return Array.from(this.form.elements);
  }
  get submitButton() {
    return this.form.querySelector("[type='submit']");
  }
  initSubmit() {
    this.form.addEventListener("submit", (n) => {
      n.preventDefault(), this.submit();
    });
  }
  initButtonSubmit() {
    var n;
    (n = this.submitButton) == null || n.addEventListener("click", (a) => {
      a.preventDefault(), this.submit();
    });
  }
  initFields() {
    this.fields.forEach((n) => {
      var a = n.getAttribute("validation");
      if (a == "phone") {
        var s = n.getAttribute("default-country-code");
        n.value = s ? `+${s}` : "", this.initPhoneField(n, s == null);
      }
      if (n.type.toLowerCase() == "checkbox") {
        var h = n.getAttribute("default-checked");
        h && (n.checked = !0);
      }
      n.addEventListener("blur", (g) => {
        n.touched = !0, this.fieldChangeHandler(g);
      }), n.addEventListener("keyup", this.fieldChangeHandler.bind(this)), n.addEventListener("change", this.fieldChangeHandler.bind(this));
    });
  }
  hideFieldsIfAuthorized() {
    typeof this.isAuthorized == "function" && this.isAuthorized() && this.fields.forEach((n) => {
      var a = n.closest(".form-control");
      if (a) {
        var s = a.getAttribute("hide-if-auth") == "true";
        s && (a.remove(), this.anyFieldHiddenDueToAuth = !0);
      }
    });
  }
  initPhoneField(n, a = !1) {
    var s = {
      autoPlaceholder: "polite",
      nationalMode: !0,
      dropdownContainer: document.getElementsByClassName("ez-wrapper")[0] || document.body
    };
    a && (s.initialCountry = "auto"), n.intlTelInput = intlTelInput$2(n, s), window.its = n.intlTelInput, a && this.getCountryName().then((h) => {
      this.currentCountry = h, n.intlTelInput.setCountry(h);
    });
  }
  async getCountryName() {
    try {
      var n = api.get(CountryCookieName);
      if (n)
        return n.toLowerCase();
      var a = await fetch("https://ipinfo.io", {
        headers: { Accept: "application/json" }
      }), s = await a.json(), h = s && s.country ? s.country : "us";
      return api.set(CountryCookieName, h.toLowerCase(), { expires: 7 }), h.toLowerCase();
    } catch {
      return "us";
    }
  }
  get accelPixel() {
    var n = window.ao;
    return n || null;
  }
  get formMessageToShow() {
    const n = this.form.getAttribute("form-message");
    return n && n.length > 0 ? n : "";
  }
  showMessage(n) {
    var a = document.createElement("div");
    a.className = "ez-form-message", this.form.appendChild(a), a.innerText = n || "Thank you!";
  }
  showError(n, a) {
    var h;
    var s = document.createElement("div");
    s.className = "form-error", (h = this.form) == null || h.appendChild(s), s.innerText = n, setTimeout(() => {
      s.remove();
    }, (a || 3) * 1e3);
  }
  addVariablesToString(n) {
    var h, g;
    for (var a of this.formData.fields) {
      var s = a.value || "";
      typeof s == "string" && (s = s.replace(/[+]/g, "%2B")), typeof s == "boolean" ? n = n.replace(new RegExp(`(#|{)(${a.key})(#|})`, "g"), s ? "true" : "false") : n = n.replace(new RegExp(`(#|{)(${a.key}|${a.name})(#|})`, "g"), s);
    }
    return (g = (h = this.formResponse) == null ? void 0 : h.body) != null && g.contactId && (n = replaceAXLVariables(n, AXLReplaceTags.Id, this.formResponse.body.contactId)), n;
  }
  async execJS() {
    var n = this.form.getAttribute("form-js");
    if (n)
      try {
        var a = new Function(n);
        await a();
      } catch (s) {
        console.error("Error in form JS function", s);
      }
  }
  execRedirect() {
    var h, g;
    let n = this.form.getAttribute("form-redirect");
    if (!n || n.length == 0)
      return;
    if (n = this.addVariablesToString(n), this.form.getAttribute("form-redirect-add-url-params"))
      for (var s of getUrlVars(document.location.href))
        n = updateOrSetQueryStringParam(n, s.key, s.value);
    if (this.formParams && this.formParams.contactQueryCookieName && ((g = (h = this.formResponse) == null ? void 0 : h.body) != null && g.contactId) && (n = updateOrSetQueryStringParam(n, this.formParams.contactQueryCookieName, this.formResponse.body.contactId)), isInsideWidget()) {
      emulateClick(n, null);
      return;
    }
    document.location.href = n;
  }
  async submit() {
    var R, S, O, C;
    if (!this.isSubmitting) {
      this.setIsSubmitting(!0), this.fields.forEach((D) => this.fieldHideError(D));
      var n = [];
      for (var a of this.fields)
        n.push(this.fieldIsValid(a));
      var s = n.filter((D) => D.isValid == !1);
      if (s.length > 0) {
        s.forEach((D) => this.fieldShowError(D)), this.setIsSubmitting(!1), (R = s[0].dom.parentElement) == null || R.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        return;
      }
      var h = {
        name: this.form.getAttribute("form-name"),
        fields: []
      };
      for (var a of this.fields) {
        let H = a.getAttribute("type") == "checkbox" ? a.checked : a.value;
        var g = a.intlTelInput;
        g && (H = g.getNumber()), h.fields.push({
          key: a.getAttribute("name"),
          name: a.getAttribute("label"),
          value: H
        });
      }
      if (this.anyFieldHiddenDueToAuth && h.fields.push({
        key: "isAuthorized",
        name: "isAuthorized",
        value: "true"
      }), this.formData = h, this.accelPixel)
        this.accelPixel.track("form", this.formData, this.sendFormCallBack);
      else if ((S = this.formParams) != null && S.onSubmit)
        try {
          var { status: m, data: v } = await ((O = this.formParams) == null ? void 0 : O.onSubmit(this.formData));
          await this.sendFormCallBack({ status: m, data: v });
        } catch {
          this.showError("Error submitting form. Please try again later.");
        }
      else if ((C = this.formParams) != null && C.submitUrl)
        try {
          var w = await fetch(this.formParams.submitUrl, {
            method: "POST",
            headers: { Accept: "application/json" },
            body: JSON.stringify(this.formData)
          }), v = await w.json();
          await this.sendFormCallBack({ status: w.status, data: v });
        } catch {
          this.showError("Error submitting form. Please try again later.");
        }
      else {
        if (!this.accelPixel) {
          console.warn("Can't find Accel Pixel. This is sad. Configure your Accel Pixel to send forms"), this.setIsSubmitting(!1);
          return;
        }
        if (!this.accelPixel.track) {
          console.warn("Track form is not configured."), this.setIsSubmitting(!1);
          return;
        }
      }
    }
  }
  setIsSubmitting(n) {
    var a, s;
    n ? ((s = this.submitButton) == null || s.setAttribute("disabled", "disabled"), this.isSubmitting = !0, this.createLoader()) : ((a = this.submitButton) == null || a.removeAttribute("disabled"), this.isSubmitting = !1, this.destroyLoader());
  }
  createLoader() {
    this.loader = document.createElement("div"), this.loader.className = "spin-loader-wrapper";
    var n = document.createElement("div");
    n.className = "spin-loader", this.loader.appendChild(n), this.form.appendChild(this.loader);
  }
  destroyLoader() {
    this.loader && (this.loader.remove(), this.loader = null);
  }
}
class FormLocalization {
  constructor(n) {
    var s, h;
    if (this.words = new FormLocalizationWordsEn(), n)
      this.words = n;
    else {
      var a = (h = (s = Intl.NumberFormat()) == null ? void 0 : s.resolvedOptions()) == null ? void 0 : h.locale;
      switch (a || (a = navigator.language || "us"), a.indexOf("-") > -1 && (a = a.split("-")[0]), a) {
        case "en":
          this.words = new FormLocalizationWordsEn();
          break;
        case "ru":
          this.words = new FormLocalizationWordsRu();
          break;
      }
    }
  }
}
class FormLocalizationWordsEn {
  constructor() {
    this.invalidEmail = "Enter valid email", this.invalidPhone = "Enter international phone number", this.invalidNumber = "Enter valid number", this.invalidUrl = "Enter valid URL", this.required = "This field is required";
  }
}
class FormLocalizationWordsRu {
  constructor() {
    this.invalidEmail = "Введите корректный email", this.invalidPhone = "Введите телефон в международном формате", this.invalidNumber = "Введите корректное число", this.invalidUrl = "Введите корректный URL", this.required = "Обязательно для заполнения";
  }
}
const zoomImage = (r, n) => {
  var a = document.body.style.overflow, s = document.createElement("div");
  s.classList.add("ez-zoom-image-holder");
  const h = () => {
    s.classList.add("hide"), setTimeout(() => {
      s.remove(), document.body.style.overflow = a;
    }, 300);
  };
  var g = document.createElement("div");
  g.classList.add("backdrop"), g.addEventListener("click", h), s.append(g);
  var m = document.createElement("img");
  m.src = r, m.addEventListener("click", h), s.append(m), n.append(s), document.body.style.overflow = "hidden", m.height < window.innerHeight && m.classList.add("center");
}, POPUP_HOLDER_CLASS = "ez-popup-holder", POPUP_CLASS = "ez-popup", POPUP_CLOSE_CLASS = "ez-popup-close", POPUP_SHOWN_CLASS = "shown", POPUP_BACKDROP_CLASS = "ez-popup-backdrop", POPUP_AUTO_SHOW_ATTR = "ez-popup-auto-show", BODY_POPUP_SHOW_CLASS = "ez-popup-shown", BODY_MIN_HEIGHT_CACHE = "bodyMinHeightCache", BODY_SCROLL_CACHE = "bodyScrollCache", initPopupTimers = (r) => {
  const n = document.querySelectorAll(`${r} .${POPUP_CLASS}`);
  for (let a = 0; a < n.length; a++) {
    const s = n[a], h = s.getAttribute(POPUP_AUTO_SHOW_ATTR);
    if (h) {
      const g = parseInt(h || "0");
      g > 0 && setTimeout(() => {
        showPopup(s.id);
      }, g * 1e3);
    }
  }
}, hidePopup = () => {
  const r = document.querySelectorAll(`.${POPUP_CLASS}.${POPUP_SHOWN_CLASS}`);
  if (r.length != 0) {
    for (let s = 0; s < r.length; s++) {
      var n = r[s];
      n.classList.remove(POPUP_SHOWN_CLASS), document.body.classList.remove(BODY_POPUP_SHOW_CLASS), document.body.style.position = "", document.body.style.top = "";
      const h = n.closest(`.${POPUP_HOLDER_CLASS}`);
      if (h) {
        h.classList.remove(POPUP_SHOWN_CLASS);
        const m = h.querySelector(`.${POPUP_BACKDROP_CLASS}`);
        m && (m.removeEventListener("click", hidePopup), m.classList.remove(POPUP_SHOWN_CLASS));
      }
      const g = n.querySelector("." + POPUP_CLOSE_CLASS);
      if (g && g.remove(), isInsideWidget()) {
        const m = document.querySelector("body");
        m && (h.style.overflow = "auto", m.style.minHeight = n[BODY_MIN_HEIGHT_CACHE] || "", window.dispatchEvent(new Event("resize")));
      }
    }
    var a = r[r.length - 1];
    a && window.scrollTo(0, a[BODY_SCROLL_CACHE]);
  }
}, showPopup = (r) => {
  const n = document.getElementById(r);
  if (!n || n.classList.contains(POPUP_CLASS) == !1)
    return;
  const a = n.closest(`.${POPUP_HOLDER_CLASS}`);
  if (!a || a.classList.contains(POPUP_HOLDER_CLASS) == !1)
    return;
  a.classList.add(POPUP_SHOWN_CLASS);
  const s = a.querySelector(`.${POPUP_BACKDROP_CLASS}`);
  s && (s.addEventListener("click", hidePopup), s.classList.add(POPUP_SHOWN_CLASS)), n.classList.add(POPUP_SHOWN_CLASS), document.body.classList.add(BODY_POPUP_SHOW_CLASS), n[BODY_SCROLL_CACHE] = window.pageYOffset || document.documentElement.scrollTop, document.body.style.position = "fixed", document.body.style.top = `-${n[BODY_SCROLL_CACHE]}px`;
  const h = document.createElement("div");
  if (h.classList.add(POPUP_CLOSE_CLASS), h.innerHTML = "×", h.addEventListener("click", hidePopup), n.appendChild(h), isInsideWidget()) {
    const g = document.querySelector("body");
    g && (a.style.overflow = "hidden", n[BODY_MIN_HEIGHT_CACHE] = g.style.minHeight, g.style.minHeight = n.scrollHeight + 40 + "px", window.dispatchEvent(new Event("resize")));
  }
}, initClicks = (r) => {
  const n = document.querySelectorAll(`${r} [${ACTION_ATTR}], ${r} .ez [href]`);
  for (var a = 0; a < n.length; a++) {
    const s = n[a], h = s.getAttribute("href"), g = s.getAttribute("type") == "submit";
    g && s.removeAttribute("href"), h ? g ? s._onSuccessFormSubmit = () => emulateClick(h || "", s.getAttribute("target")) : s.addEventListener("click", (m) => {
      m.preventDefault(), emulateClick(h || "", s.getAttribute("target"));
    }) : g ? s._onSuccessFormSubmit = () => clickActionHandler(s) : s.addEventListener("click", () => clickActionHandler(s));
  }
}, clickActionHandler = (r) => {
  if (!r)
    return;
  const n = JSON.parse(r.getAttribute(ACTION_ATTR) || "");
  n.length > 0 && clickActionRun(0, n, r);
}, clickActionRun = async (index, actions, target) => {
  const currentAction = actions[index];
  if (currentAction)
    switch (currentAction.type) {
      case "link":
        const linkTo = replaceAXLVariables(currentAction.href || "", AXLReplaceTags.Id, axl_contactId());
        emulateClick(linkTo || "", currentAction.blank ? "_blank" : null);
        break;
      case "file":
        if (!currentAction.data)
          break;
        var fileUrl = `${axl_fileDownloadUrl()}/${currentAction.data}`;
        try {
          if (typeof axl_clickActions.fileDownload == "function") {
            var fileUrlResult = await axl_clickActions.fileDownload(currentAction.data);
            fileUrlResult && (fileUrl = fileUrlResult);
          }
        } catch (r) {
          console.error(r);
        }
        target.setAttribute("download", "true"), emulateClick(`${fileUrl}`, "_blank"), await clickActionRun(index + 1, actions, target);
        break;
      case "addToCart":
        var fastCheckout = currentAction.data2 == !0;
        await window.accel_checkout.cart.addToCart(currentAction.data, 1, fastCheckout), await clickActionRun(index + 1, actions, target);
        break;
      case "removeFromCart":
        var fullRemove = currentAction.data2 == !0;
        await window.accel_checkout.cart.removeFromCart(currentAction.data, fullRemove), await clickActionRun(index + 1, actions, target);
        break;
      case "goToCheckout":
        var checkoutUrl = `${axl_base_uri}/checkout`;
        isInsideWidget() && (axl_contactQueryStringParam && axl_contactId() && (checkoutUrl = updateOrSetQueryStringParam(checkoutUrl, axl_contactQueryStringParam, axl_contactId())), axl_guestQueryStringParam && axl_guestId() && (checkoutUrl = updateOrSetQueryStringParam(checkoutUrl, axl_guestQueryStringParam, axl_guestId()))), emulateClick(checkoutUrl, null);
        break;
      case "moveToSection":
        if (currentAction.data) {
          const r = document.getElementById(currentAction.data);
          if (r) {
            const n = document.querySelector(".ez-wrapper");
            if (n) {
              const a = r.offsetTop - n.offsetTop;
              document.body.scrollTop = a, document.documentElement.scrollTop = a;
            } else
              r.scrollIntoView({ block: "start" });
          }
        }
        await clickActionRun(index + 1, actions, target);
        break;
      case "redirectToCourseStep":
        window.goToCourseStep(currentAction.data);
        break;
      case "imageZoom":
        var src = null;
        if (target.nodeName == "IMG")
          src = target.getAttribute("src");
        else {
          var img = target.querySelector("img");
          src = img.getAttribute("src");
        }
        if (!src)
          break;
        var container = document.getElementsByClassName("ez-wrapper")[0];
        container && src && src.length > 0 && zoomImage(src, container);
        break;
      case "refreshPage":
        window.location.reload();
        break;
      case "runJS":
        const js = currentAction.data;
        try {
          if (js) {
            var replaced = replaceAXLVariables(js, AXLReplaceTags.Id, axl_contactId());
            eval(decodeURIComponent(replaced));
          }
        } finally {
          await clickActionRun(index + 1, actions, target);
          break;
        }
      case "runCustomEvent":
        try {
          axl_clickActions.runCustomEvent != null && await axl_clickActions.runCustomEvent(currentAction);
        } finally {
          await clickActionRun(index + 1, actions, target);
          break;
        }
      case "showPopup":
        showPopup(currentAction.data), await clickActionRun(index + 1, actions, target);
        break;
      default:
        await clickActionRun(index + 1, actions, target);
    }
}, initAudios = (r) => {
  for (var n = document.querySelectorAll(`${r} .ez-audio audio`), a = 0; a < n.length; a++) {
    const h = n[a];
    if (!h.src) {
      var s = h.getAttribute("axlfileid");
      s && (h.src = `${axl_fileDownloadUrl()}/${s}`);
    }
  }
}, initHtmlEmbeds = (r) => {
  for (var n = document.querySelectorAll(`${r} .ez-html`), a = 0; a < n.length; a++) {
    const s = n[a];
    try {
      const h = s.querySelector(".ez-html-content[content]");
      if (!h)
        continue;
      let g = decodeURIComponent(h.getAttribute("content") || "");
      g = g.replace(/&nbsp;/g, " "), s.innerHTML = g;
      const m = (v) => {
        var w = s.querySelectorAll("script");
        const R = w[v];
        if (!R)
          return !0;
        const S = document.createElement("script");
        Array.from(R.attributes).forEach((O) => S.setAttribute(O.name, O.value)), S.appendChild(document.createTextNode(R.innerHTML)), R.parentNode && R.parentNode.replaceChild(S, R), S.getAttribute("onload") ? m(v + 1) : S.onload = () => {
          m(v + 1);
        };
      };
      m(0);
    } catch {
      s.remove();
    }
  }
}, initMenuToggle = (r) => {
  const n = document.querySelectorAll(`${r} .ez-menu-collapse-btn`);
  for (let a = 0; a < n.length; a++) {
    const s = n[a];
    s && s.addEventListener("click", showMenu);
  }
}, showMenu = (r) => {
  const n = r.currentTarget;
  if (!n)
    return;
  const a = n.closest(".ez-menu");
  a && a.classList.toggle("shown");
  const s = n.closest(".ez-section");
  s && s.classList.toggle("menu-shown");
}, initPseudoClicks = (r) => {
  for (var n = document.querySelectorAll(`${r} [${PSEUDO_CLICK_ATTR}]`), a = 0; a < n.length; a++) {
    const s = n[a];
    if (s != null) {
      const h = s.getAttribute("href"), g = s.getAttribute("target");
      h && (s.onclick = () => {
        emulateClick(h, g);
      });
    }
  }
}, checkConditionCache = [], isInFilter = async (r) => {
  var s;
  const n = axl_contactId() || "";
  var a = (s = checkConditionCache.find((h) => h.contactId == n && h.filterId == r)) == null ? void 0 : s.result;
  return typeof a > "u" && (a = await axl_userIsInFilter(n, r), checkConditionCache.push({ contactId: n, filterId: r, result: a || !1 })), a;
}, initConditions = async (r) => {
  var w;
  const n = document.querySelectorAll(`${r} [${CONDITION_ATTR}]`);
  for (var a = 0; a < n.length; a++) {
    const R = n[a];
    R.style.visibility = "hidden";
  }
  window.dispatchEvent(new Event("resize"));
  for (var a = 0; a < n.length; a++) {
    const S = n[a], O = JSON.parse(S.getAttribute(CONDITION_ATTR) || "[]");
    for (var s = 0; s < O.length; s++) {
      const C = O[s];
      if (!S)
        continue;
      const D = axl_contactId() != null;
      switch (C.type) {
        case "userIsAuth":
          (C.case == "showOnlyIf" && !D || C.case == "hideIf" && D) && S.remove();
          break;
        case "userIsNotAuth":
          (C.case == "showOnlyIf" && D || C.case == "hideIf" && !D) && S.remove();
          break;
        case "urlParam":
          const H = document.location.search, W = new URLSearchParams(H);
          if (C.data && typeof C.data == "object" && C.data.key && C.data.value) {
            var h = W.get((w = C.data) == null ? void 0 : w.key.trim()) == C.data.value.trim();
            (C.case == "showOnlyIf" && !h || C.case == "hideIf" && h) && S.remove();
          }
          break;
        case "urlContains":
          var g = document.location.href.indexOf(C.data) > -1;
          (C.case == "showOnlyIf" && !g || C.case == "hideIf" && g) && S.remove();
          break;
        case "userUnderFilter":
          if (!D && C.case == "showOnlyIf") {
            S.remove();
            break;
          }
          var m = await isInFilter(C.data);
          (C.case == "showOnlyIf" && m != !0 || C.case == "hideIf" && m == !0) && S.remove();
          break;
        case "userNotUnderFilter":
          if (!D && C.case == "hideIf") {
            S.remove();
            break;
          }
          var m = await isInFilter(C.data);
          (C.case == "showOnlyIf" && m != !1 || C.case == "hideIf" && m == !1) && S.remove();
          break;
        case "dateTime":
          try {
            let z = JSON.parse(C.data);
            if (!z.date)
              break;
            let Z = new Date(z.date), p = getComputedStyle(S).display, f = p, l = null, t = null;
            if (C.case == "showOnlyIf")
              switch (z.condition) {
                case "<":
                  t = Z, f = "none";
                  break;
                case ">":
                  l = Z, f = p;
                  break;
                case "period":
                  z.date2 && (l = Z, t = new Date(z.date2), f = p);
                  break;
              }
            else if (C.case == "hideIf")
              switch (z.condition) {
                case "<":
                  l = Z, f = p;
                  break;
                case ">":
                  t = Z, f = "none";
                  break;
                case "period":
                  z.date2 && (t = Z, l = new Date(z.date2), f = "none");
                  break;
              }
            checkConditionDateTime(S, p, l, t);
            let o = setInterval(() => {
              var u = checkConditionDateTime(S, p, l, t);
            }, 1e3);
          } catch {
            console.warn("Invalid condition data", C.data);
            break;
          }
          break;
        case "timeOfTheDay":
          try {
            let z = JSON.parse(C.data);
            if (!z.date)
              break;
            let Z = z.date, p = getComputedStyle(S).display, f = p, l = null, t = null;
            if (C.case == "showOnlyIf")
              switch (z.condition) {
                case "<":
                  t = Z, f = "none";
                  break;
                case ">":
                  l = Z, f = p;
                  break;
                case "period":
                  z.date2 && (l = Z, t = z.date2, f = p);
                  break;
              }
            else if (C.case == "hideIf")
              switch (z.condition) {
                case "<":
                  l = Z, f = p;
                  break;
                case ">":
                  t = Z, f = "none";
                  break;
                case "period":
                  z.date2 && (l = z.date2, t = Z, f = "none");
                  break;
              }
            checkConditionTime(S, p, l, t);
            let o = setInterval(() => {
              var u = checkConditionTime(S, p, l, t);
            }, 1e3);
          } catch {
            console.warn("Invalid condition data", C.data);
            break;
          }
          break;
        case "weekDay":
          let N = JSON.parse(C.data);
          if (!N.weekDays)
            break;
          var v = (/* @__PURE__ */ new Date()).getDay();
          N.weekDays.indexOf(v) == -1 ? C.case == "showOnlyIf" && S.remove() : C.case == "hideIf" && S.remove();
          break;
      }
    }
    S.style.visibility = "";
  }
  window.dispatchEvent(new Event("resize"));
}, checkConditionDateTime = (r, n, a, s) => {
  var h = getComputedStyle(r).display, g = h, m = (/* @__PURE__ */ new Date()).getTime();
  if (a && s) {
    var v = s.getTime() < a.getTime();
    v ? m > s.getTime() && m < a.getTime() ? g = "none" : g = n : m > a.getTime() && m < s.getTime() ? g = n : g = "none";
  } else
    a ? m >= a.getTime() ? g = n : g = "none" : s && (m < s.getTime() ? g = n : g = "none");
  return h != g && window.dispatchEvent(new Event("resize")), r.style.display = g, g;
}, checkConditionTime = (r, n, a, s) => {
  var h = getComputedStyle(r).display, g = h, m = /* @__PURE__ */ new Date(), v = m.getUTCHours() * 60 + m.getUTCMinutes(), w = parseInt((a == null ? void 0 : a.split(":")[0]) || "0") * 60 + parseInt((a == null ? void 0 : a.split(":")[1]) || "0"), R = parseInt((s == null ? void 0 : s.split(":")[0]) || "0") * 60 + parseInt((s == null ? void 0 : s.split(":")[1]) || "0");
  if (s == "00:00" && (R = 24 * 60), a && s) {
    var S = R > w;
    S ? v >= w && v < R ? g = n : g = "none" : v < R || v >= w ? g = n : g = "none";
  } else
    a ? v >= w ? g = n : g = "none" : s && (v < R ? g = n : g = "none");
  return h != g && window.dispatchEvent(new Event("resize")), r.style.display = g, g;
}, QUIZ_ID_ATTR = "ez-quiz-id", triggerResize = (r) => {
  window.dispatchEvent(new CustomEvent("resize", {
    detail: {
      height: r.scrollHeight
    }
  }));
}, initQuiz = (r) => {
  var s;
  var n = document.querySelectorAll(`${r} .ez-quiz`);
  if (n.length == 0)
    return;
  const a = (s = window.AXLData) == null ? void 0 : s.quizSettings;
  if (!a) {
    console.error("Couldn't init quiz. AXLData.quizSettings is undefined", r);
    return;
  }
  injectStyle(a.styleSrc), injectScript(a.scriptSrc).then(() => {
    for (var h = 0; h < n.length; h++) {
      const g = n[h], m = g.parentElement;
      try {
        const v = g.getAttribute(QUIZ_ID_ATTR);
        g.quiz = new window.AccelQuiz({
          container: g,
          quizId: v,
          lang: a.lang,
          loc: a.loc,
          config: a.config,
          onRedirect: (w, R) => emulateClick(w, R ? "_blank" : "_self"),
          // trigger to recalc widget viewport
          onMounted: () => triggerResize(m ?? g),
          onPageSwitched: () => {
            setTimeout(() => {
              triggerResize(m ?? g);
            }, 200);
          },
          onCompleted: (w) => {
            window.AXLWebsite && window.AXLWebsite.dispatch(AXLWebsiteEventEnum.FormSubmit, w), setTimeout(() => {
              triggerResize(m ?? g);
            }, 200);
          },
          onContactChanged: (w) => {
            var R;
            (R = window.ao) == null || R.setContactId(w);
          }
        });
      } catch {
        g.remove();
      }
    }
  });
};
function initEZTimers(r) {
  for (var n = document.querySelectorAll(`${r} .ez-timer`), a = 0; a < n.length; a++)
    EZTimerInit(n[a]);
}
function EZTimerInit(r) {
  if (!r.timer) {
    r.targetLengthCache = r.getAttribute(
      "lengthSec"
      /* targetLengthSec */
    );
    var n = setInterval(() => {
      if (!r.parentElement) {
        clearInterval(n);
        return;
      }
      EZTimerPlay(r);
    }, 1e3);
    r.timer = n;
  }
}
function EZTimerPlay(r) {
  var n = r.getAttribute(
    "mode"
    /* mode */
  ), a = 0;
  switch (n) {
    case "length":
      var s = r.targetLengthCache != r.getAttribute(
        "lengthSec"
        /* targetLengthSec */
      );
      if (a = r.secondsLeft, !a || s) {
        var h = parseInt(r.getAttribute(
          "lengthSec"
          /* targetLengthSec */
        ) || "0");
        r.targetLengthCache = h.toString(), r.secondsLeft = h, a = r.secondsLeft;
      }
      break;
    case "date":
      try {
        var g = r.getAttribute(
          "dateTime"
          /* targetDateTime */
        ), m = new Date(g);
        a = Math.floor((m.getTime() - Date.now()) / 1e3), a < 0 && (a = 0);
      } catch {
        a = 0;
      }
  }
  var v = Math.floor(a / 86400), w = Math.floor(a % 86400 / 3600), R = Math.floor(a % 3600 / 60), S = a % 60, O = r.querySelector(".dd");
  if (O) {
    var C = O.querySelector(".n");
    C && (C.innerHTML = v < 10 ? "0" + v : "" + v);
  }
  var D = r.querySelector(".hh");
  if (D) {
    var C = D.querySelector(".n");
    C && (C.innerHTML = w < 10 ? "0" + w : "" + w);
  }
  var H = r.querySelector(".mm");
  if (H) {
    var C = H.querySelector(".n");
    C && (C.innerHTML = R < 10 ? "0" + R : "" + R);
  }
  var W = r.querySelector(".ss");
  if (W) {
    var C = W.querySelector(".n");
    C && (C.innerHTML = S < 10 ? "0" + S : "" + S);
  }
  r.secondsLeft && (r.secondsLeft -= 1);
}
const PSEUDO_CLICK_ATTR = "ezclick", ACTION_ATTR = "ezactions", CONDITION_ATTR = "ez-show-hide", WRAPPER_CLASS = "ez-wrapper";
let axl_base_uri = "", axl_clickActions = {}, axl_fileDownloadUrl = () => `${axl_base_uri}/file/download`, axl_userIsInFilter = async (r, n) => !1, axl_contactId = () => "", axl_contactQueryStringParam, axl_guestId = () => "", axl_guestQueryStringParam;
const ezInitMain = (r) => {
  (r.holderSelector == "" || !r.holderSelector) && (r.holderSelector = "body"), r.baseUrl && (axl_base_uri = r.baseUrl), r.clickActions && (axl_clickActions = r.clickActions), r.userIsInFilter && (axl_userIsInFilter = r.userIsInFilter), typeof r.contactId == "function" && (axl_contactId = r.contactId), axl_contactQueryStringParam = r.contactQueryStringParam, typeof r.questId == "function" && (axl_guestId = r.questId), axl_guestQueryStringParam = r.guestQueryStringParam, makeIframesLazy(), initHtmlEmbeds(r.holderSelector), initPseudoClicks(r.holderSelector), initClicks(r.holderSelector), initConditions(r.holderSelector), initMenuToggle(r.holderSelector), initAudios(r.holderSelector), initPopupTimers(r.holderSelector), initQuiz(r.holderSelector), initEZTimers(r.holderSelector), document.querySelectorAll(`.${WRAPPER_CLASS}`).forEach((s) => {
    s.classList.add("live");
  });
  var a = window.AXLWebsite;
  a && (a.showPopup = (s) => showPopup(s), a.hidePopup = () => hidePopup(), a.zoomImage = (s, h) => {
    var g = h || document.getElementsByClassName("ez-wrapper")[0];
    g && s && s.length > 0 && zoomImage(s, g);
  });
};
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var r = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
  function s(g) {
    if (g == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(g);
  }
  function h() {
    try {
      if (!Object.assign)
        return !1;
      var g = new String("abc");
      if (g[5] = "de", Object.getOwnPropertyNames(g)[0] === "5")
        return !1;
      for (var m = {}, v = 0; v < 10; v++)
        m["_" + String.fromCharCode(v)] = v;
      var w = Object.getOwnPropertyNames(m).map(function(S) {
        return m[S];
      });
      if (w.join("") !== "0123456789")
        return !1;
      var R = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(S) {
        R[S] = S;
      }), Object.keys(Object.assign({}, R)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = h() ? Object.assign : function(g, m) {
    for (var v, w = s(g), R, S = 1; S < arguments.length; S++) {
      v = Object(arguments[S]);
      for (var O in v)
        n.call(v, O) && (w[O] = v[O]);
      if (r) {
        R = r(v);
        for (var C = 0; C < R.length; C++)
          a.call(v, R[C]) && (w[R[C]] = v[R[C]]);
      }
    }
    return w;
  }, objectAssign;
}
var react = { exports: {} }, react_production_min = {};
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReact_production_min;
function requireReact_production_min() {
  if (hasRequiredReact_production_min)
    return react_production_min;
  hasRequiredReact_production_min = 1;
  var r = requireObjectAssign(), n = 60103, a = 60106;
  react_production_min.Fragment = 60107, react_production_min.StrictMode = 60108, react_production_min.Profiler = 60114;
  var s = 60109, h = 60110, g = 60112;
  react_production_min.Suspense = 60113;
  var m = 60115, v = 60116;
  if (typeof Symbol == "function" && Symbol.for) {
    var w = Symbol.for;
    n = w("react.element"), a = w("react.portal"), react_production_min.Fragment = w("react.fragment"), react_production_min.StrictMode = w("react.strict_mode"), react_production_min.Profiler = w("react.profiler"), s = w("react.provider"), h = w("react.context"), g = w("react.forward_ref"), react_production_min.Suspense = w("react.suspense"), m = w("react.memo"), v = w("react.lazy");
  }
  var R = typeof Symbol == "function" && Symbol.iterator;
  function S(_) {
    return _ === null || typeof _ != "object" ? null : (_ = R && _[R] || _["@@iterator"], typeof _ == "function" ? _ : null);
  }
  function O(_) {
    for (var A = "https://reactjs.org/docs/error-decoder.html?invariant=" + _, U = 1; U < arguments.length; U++)
      A += "&args[]=" + encodeURIComponent(arguments[U]);
    return "Minified React error #" + _ + "; visit " + A + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var C = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, D = {};
  function H(_, A, U) {
    this.props = _, this.context = A, this.refs = D, this.updater = U || C;
  }
  H.prototype.isReactComponent = {}, H.prototype.setState = function(_, A) {
    if (typeof _ != "object" && typeof _ != "function" && _ != null)
      throw Error(O(85));
    this.updater.enqueueSetState(this, _, A, "setState");
  }, H.prototype.forceUpdate = function(_) {
    this.updater.enqueueForceUpdate(this, _, "forceUpdate");
  };
  function W() {
  }
  W.prototype = H.prototype;
  function N(_, A, U) {
    this.props = _, this.context = A, this.refs = D, this.updater = U || C;
  }
  var z = N.prototype = new W();
  z.constructor = N, r(z, H.prototype), z.isPureReactComponent = !0;
  var Z = { current: null }, p = Object.prototype.hasOwnProperty, f = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(_, A, U) {
    var G, J = {}, Q = null, X = null;
    if (A != null)
      for (G in A.ref !== void 0 && (X = A.ref), A.key !== void 0 && (Q = "" + A.key), A)
        p.call(A, G) && !f.hasOwnProperty(G) && (J[G] = A[G]);
    var oe = arguments.length - 2;
    if (oe === 1)
      J.children = U;
    else if (1 < oe) {
      for (var ne = Array(oe), fe = 0; fe < oe; fe++)
        ne[fe] = arguments[fe + 2];
      J.children = ne;
    }
    if (_ && _.defaultProps)
      for (G in oe = _.defaultProps, oe)
        J[G] === void 0 && (J[G] = oe[G]);
    return { $$typeof: n, type: _, key: Q, ref: X, props: J, _owner: Z.current };
  }
  function t(_, A) {
    return { $$typeof: n, type: _.type, key: A, ref: _.ref, props: _.props, _owner: _._owner };
  }
  function o(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === n;
  }
  function u(_) {
    var A = { "=": "=0", ":": "=2" };
    return "$" + _.replace(/[=:]/g, function(U) {
      return A[U];
    });
  }
  var y = /\/+/g;
  function E(_, A) {
    return typeof _ == "object" && _ !== null && _.key != null ? u("" + _.key) : A.toString(36);
  }
  function P(_, A, U, G, J) {
    var Q = typeof _;
    (Q === "undefined" || Q === "boolean") && (_ = null);
    var X = !1;
    if (_ === null)
      X = !0;
    else
      switch (Q) {
        case "string":
        case "number":
          X = !0;
          break;
        case "object":
          switch (_.$$typeof) {
            case n:
            case a:
              X = !0;
          }
      }
    if (X)
      return X = _, J = J(X), _ = G === "" ? "." + E(X, 0) : G, Array.isArray(J) ? (U = "", _ != null && (U = _.replace(y, "$&/") + "/"), P(J, A, U, "", function(fe) {
        return fe;
      })) : J != null && (o(J) && (J = t(J, U + (!J.key || X && X.key === J.key ? "" : ("" + J.key).replace(y, "$&/") + "/") + _)), A.push(J)), 1;
    if (X = 0, G = G === "" ? "." : G + ":", Array.isArray(_))
      for (var oe = 0; oe < _.length; oe++) {
        Q = _[oe];
        var ne = G + E(Q, oe);
        X += P(Q, A, U, ne, J);
      }
    else if (ne = S(_), typeof ne == "function")
      for (_ = ne.call(_), oe = 0; !(Q = _.next()).done; )
        Q = Q.value, ne = G + E(Q, oe++), X += P(Q, A, U, ne, J);
    else if (Q === "object")
      throw A = "" + _, Error(O(31, A === "[object Object]" ? "object with keys {" + Object.keys(_).join(", ") + "}" : A));
    return X;
  }
  function F(_, A, U) {
    if (_ == null)
      return _;
    var G = [], J = 0;
    return P(_, G, "", "", function(Q) {
      return A.call(U, Q, J++);
    }), G;
  }
  function x(_) {
    if (_._status === -1) {
      var A = _._result;
      A = A(), _._status = 0, _._result = A, A.then(function(U) {
        _._status === 0 && (U = U.default, _._status = 1, _._result = U);
      }, function(U) {
        _._status === 0 && (_._status = 2, _._result = U);
      });
    }
    if (_._status === 1)
      return _._result;
    throw _._result;
  }
  var $ = { current: null };
  function V() {
    var _ = $.current;
    if (_ === null)
      throw Error(O(321));
    return _;
  }
  var re = { ReactCurrentDispatcher: $, ReactCurrentBatchConfig: { transition: 0 }, ReactCurrentOwner: Z, IsSomeRendererActing: { current: !1 }, assign: r };
  return react_production_min.Children = { map: F, forEach: function(_, A, U) {
    F(_, function() {
      A.apply(this, arguments);
    }, U);
  }, count: function(_) {
    var A = 0;
    return F(_, function() {
      A++;
    }), A;
  }, toArray: function(_) {
    return F(_, function(A) {
      return A;
    }) || [];
  }, only: function(_) {
    if (!o(_))
      throw Error(O(143));
    return _;
  } }, react_production_min.Component = H, react_production_min.PureComponent = N, react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = re, react_production_min.cloneElement = function(_, A, U) {
    if (_ == null)
      throw Error(O(267, _));
    var G = r({}, _.props), J = _.key, Q = _.ref, X = _._owner;
    if (A != null) {
      if (A.ref !== void 0 && (Q = A.ref, X = Z.current), A.key !== void 0 && (J = "" + A.key), _.type && _.type.defaultProps)
        var oe = _.type.defaultProps;
      for (ne in A)
        p.call(A, ne) && !f.hasOwnProperty(ne) && (G[ne] = A[ne] === void 0 && oe !== void 0 ? oe[ne] : A[ne]);
    }
    var ne = arguments.length - 2;
    if (ne === 1)
      G.children = U;
    else if (1 < ne) {
      oe = Array(ne);
      for (var fe = 0; fe < ne; fe++)
        oe[fe] = arguments[fe + 2];
      G.children = oe;
    }
    return {
      $$typeof: n,
      type: _.type,
      key: J,
      ref: Q,
      props: G,
      _owner: X
    };
  }, react_production_min.createContext = function(_, A) {
    return A === void 0 && (A = null), _ = { $$typeof: h, _calculateChangedBits: A, _currentValue: _, _currentValue2: _, _threadCount: 0, Provider: null, Consumer: null }, _.Provider = { $$typeof: s, _context: _ }, _.Consumer = _;
  }, react_production_min.createElement = l, react_production_min.createFactory = function(_) {
    var A = l.bind(null, _);
    return A.type = _, A;
  }, react_production_min.createRef = function() {
    return { current: null };
  }, react_production_min.forwardRef = function(_) {
    return { $$typeof: g, render: _ };
  }, react_production_min.isValidElement = o, react_production_min.lazy = function(_) {
    return { $$typeof: v, _payload: { _status: -1, _result: _ }, _init: x };
  }, react_production_min.memo = function(_, A) {
    return { $$typeof: m, type: _, compare: A === void 0 ? null : A };
  }, react_production_min.useCallback = function(_, A) {
    return V().useCallback(_, A);
  }, react_production_min.useContext = function(_, A) {
    return V().useContext(_, A);
  }, react_production_min.useDebugValue = function() {
  }, react_production_min.useEffect = function(_, A) {
    return V().useEffect(_, A);
  }, react_production_min.useImperativeHandle = function(_, A, U) {
    return V().useImperativeHandle(_, A, U);
  }, react_production_min.useLayoutEffect = function(_, A) {
    return V().useLayoutEffect(_, A);
  }, react_production_min.useMemo = function(_, A) {
    return V().useMemo(_, A);
  }, react_production_min.useReducer = function(_, A, U) {
    return V().useReducer(_, A, U);
  }, react_production_min.useRef = function(_) {
    return V().useRef(_);
  }, react_production_min.useState = function(_) {
    return V().useState(_);
  }, react_production_min.version = "17.0.2", react_production_min;
}
var react_development = {};
/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReact_development;
function requireReact_development() {
  return hasRequiredReact_development || (hasRequiredReact_development = 1, function(r) {
    process.env.NODE_ENV !== "production" && function() {
      var n = requireObjectAssign(), a = "17.0.2", s = 60103, h = 60106;
      r.Fragment = 60107, r.StrictMode = 60108, r.Profiler = 60114;
      var g = 60109, m = 60110, v = 60112;
      r.Suspense = 60113;
      var w = 60120, R = 60115, S = 60116, O = 60121, C = 60122, D = 60117, H = 60129, W = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var N = Symbol.for;
        s = N("react.element"), h = N("react.portal"), r.Fragment = N("react.fragment"), r.StrictMode = N("react.strict_mode"), r.Profiler = N("react.profiler"), g = N("react.provider"), m = N("react.context"), v = N("react.forward_ref"), r.Suspense = N("react.suspense"), w = N("react.suspense_list"), R = N("react.memo"), S = N("react.lazy"), O = N("react.block"), C = N("react.server.block"), D = N("react.fundamental"), N("react.scope"), N("react.opaque.id"), H = N("react.debug_trace_mode"), N("react.offscreen"), W = N("react.legacy_hidden");
      }
      var z = typeof Symbol == "function" && Symbol.iterator, Z = "@@iterator";
      function p(e) {
        if (e === null || typeof e != "object")
          return null;
        var d = z && e[z] || e[Z];
        return typeof d == "function" ? d : null;
      }
      var f = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, l = {
        transition: 0
      }, t = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, o = {}, u = null;
      function y(e) {
        u = e;
      }
      o.setExtraStackFrame = function(e) {
        u = e;
      }, o.getCurrentStack = null, o.getStackAddendum = function() {
        var e = "";
        u && (e += u);
        var d = o.getCurrentStack;
        return d && (e += d() || ""), e;
      };
      var E = {
        current: !1
      }, P = {
        ReactCurrentDispatcher: f,
        ReactCurrentBatchConfig: l,
        ReactCurrentOwner: t,
        IsSomeRendererActing: E,
        // Used by renderers to avoid bundling object-assign twice in UMD bundles:
        assign: n
      };
      P.ReactDebugCurrentFrame = o;
      function F(e) {
        {
          for (var d = arguments.length, b = new Array(d > 1 ? d - 1 : 0), I = 1; I < d; I++)
            b[I - 1] = arguments[I];
          $("warn", e, b);
        }
      }
      function x(e) {
        {
          for (var d = arguments.length, b = new Array(d > 1 ? d - 1 : 0), I = 1; I < d; I++)
            b[I - 1] = arguments[I];
          $("error", e, b);
        }
      }
      function $(e, d, b) {
        {
          var I = P.ReactDebugCurrentFrame, T = I.getStackAddendum();
          T !== "" && (d += "%s", b = b.concat([T]));
          var B = b.map(function(q) {
            return "" + q;
          });
          B.unshift("Warning: " + d), Function.prototype.apply.call(console[e], console, B);
        }
      }
      var V = {};
      function re(e, d) {
        {
          var b = e.constructor, I = b && (b.displayName || b.name) || "ReactClass", T = I + "." + d;
          if (V[T])
            return;
          x("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", d, I), V[T] = !0;
        }
      }
      var _ = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(e) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(e, d, b) {
          re(e, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(e, d, b, I) {
          re(e, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(e, d, b, I) {
          re(e, "setState");
        }
      }, A = {};
      Object.freeze(A);
      function U(e, d, b) {
        this.props = e, this.context = d, this.refs = A, this.updater = b || _;
      }
      U.prototype.isReactComponent = {}, U.prototype.setState = function(e, d) {
        if (!(typeof e == "object" || typeof e == "function" || e == null))
          throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, e, d, "setState");
      }, U.prototype.forceUpdate = function(e) {
        this.updater.enqueueForceUpdate(this, e, "forceUpdate");
      };
      {
        var G = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, J = function(e, d) {
          Object.defineProperty(U.prototype, e, {
            get: function() {
              F("%s(...) is deprecated in plain JavaScript React classes. %s", d[0], d[1]);
            }
          });
        };
        for (var Q in G)
          G.hasOwnProperty(Q) && J(Q, G[Q]);
      }
      function X() {
      }
      X.prototype = U.prototype;
      function oe(e, d, b) {
        this.props = e, this.context = d, this.refs = A, this.updater = b || _;
      }
      var ne = oe.prototype = new X();
      ne.constructor = oe, n(ne, U.prototype), ne.isPureReactComponent = !0;
      function fe() {
        var e = {
          current: null
        };
        return Object.seal(e), e;
      }
      function De(e, d, b) {
        var I = d.displayName || d.name || "";
        return e.displayName || (I !== "" ? b + "(" + I + ")" : b);
      }
      function Re(e) {
        return e.displayName || "Context";
      }
      function pe(e) {
        if (e == null)
          return null;
        if (typeof e.tag == "number" && x("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function")
          return e.displayName || e.name || null;
        if (typeof e == "string")
          return e;
        switch (e) {
          case r.Fragment:
            return "Fragment";
          case h:
            return "Portal";
          case r.Profiler:
            return "Profiler";
          case r.StrictMode:
            return "StrictMode";
          case r.Suspense:
            return "Suspense";
          case w:
            return "SuspenseList";
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case m:
              var d = e;
              return Re(d) + ".Consumer";
            case g:
              var b = e;
              return Re(b._context) + ".Provider";
            case v:
              return De(e, e.render, "ForwardRef");
            case R:
              return pe(e.type);
            case O:
              return pe(e._render);
            case S: {
              var I = e, T = I._payload, B = I._init;
              try {
                return pe(B(T));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var be = Object.prototype.hasOwnProperty, Be = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Oe, Fe, Ne;
      Ne = {};
      function Ae(e) {
        if (be.call(e, "ref")) {
          var d = Object.getOwnPropertyDescriptor(e, "ref").get;
          if (d && d.isReactWarning)
            return !1;
        }
        return e.ref !== void 0;
      }
      function $e(e) {
        if (be.call(e, "key")) {
          var d = Object.getOwnPropertyDescriptor(e, "key").get;
          if (d && d.isReactWarning)
            return !1;
        }
        return e.key !== void 0;
      }
      function He(e, d) {
        var b = function() {
          Oe || (Oe = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        b.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: b,
          configurable: !0
        });
      }
      function ke(e, d) {
        var b = function() {
          Fe || (Fe = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        b.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: b,
          configurable: !0
        });
      }
      function ot(e) {
        if (typeof e.ref == "string" && t.current && e.__self && t.current.stateNode !== e.__self) {
          var d = pe(t.current.type);
          Ne[d] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', d, e.ref), Ne[d] = !0);
        }
      }
      var we = function(e, d, b, I, T, B, q) {
        var j = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: s,
          // Built-in properties that belong on the element
          type: e,
          key: d,
          ref: b,
          props: q,
          // Record the component responsible for creating this element.
          _owner: B
        };
        return j._store = {}, Object.defineProperty(j._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(j, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: I
        }), Object.defineProperty(j, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: T
        }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
      };
      function Ue(e, d, b) {
        var I, T = {}, B = null, q = null, j = null, ae = null;
        if (d != null) {
          Ae(d) && (q = d.ref, ot(d)), $e(d) && (B = "" + d.key), j = d.__self === void 0 ? null : d.__self, ae = d.__source === void 0 ? null : d.__source;
          for (I in d)
            be.call(d, I) && !Be.hasOwnProperty(I) && (T[I] = d[I]);
        }
        var se = arguments.length - 2;
        if (se === 1)
          T.children = b;
        else if (se > 1) {
          for (var ue = Array(se), ce = 0; ce < se; ce++)
            ue[ce] = arguments[ce + 2];
          Object.freeze && Object.freeze(ue), T.children = ue;
        }
        if (e && e.defaultProps) {
          var ve = e.defaultProps;
          for (I in ve)
            T[I] === void 0 && (T[I] = ve[I]);
        }
        if (B || q) {
          var he = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          B && He(T, he), q && ke(T, he);
        }
        return we(e, B, q, j, ae, t.current, T);
      }
      function st(e, d) {
        var b = we(e.type, d, e.ref, e._self, e._source, e._owner, e.props);
        return b;
      }
      function Ve(e, d, b) {
        if (e == null)
          throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
        var I, T = n({}, e.props), B = e.key, q = e.ref, j = e._self, ae = e._source, se = e._owner;
        if (d != null) {
          Ae(d) && (q = d.ref, se = t.current), $e(d) && (B = "" + d.key);
          var ue;
          e.type && e.type.defaultProps && (ue = e.type.defaultProps);
          for (I in d)
            be.call(d, I) && !Be.hasOwnProperty(I) && (d[I] === void 0 && ue !== void 0 ? T[I] = ue[I] : T[I] = d[I]);
        }
        var ce = arguments.length - 2;
        if (ce === 1)
          T.children = b;
        else if (ce > 1) {
          for (var ve = Array(ce), he = 0; he < ce; he++)
            ve[he] = arguments[he + 2];
          T.children = ve;
        }
        return we(e.type, B, q, j, ae, se, T);
      }
      function Ce(e) {
        return typeof e == "object" && e !== null && e.$$typeof === s;
      }
      var Pe = ".", lt = ":";
      function ut(e) {
        var d = /[=:]/g, b = {
          "=": "=0",
          ":": "=2"
        }, I = e.replace(d, function(T) {
          return b[T];
        });
        return "$" + I;
      }
      var We = !1, ct = /\/+/g;
      function Ye(e) {
        return e.replace(ct, "$&/");
      }
      function je(e, d) {
        return typeof e == "object" && e !== null && e.key != null ? ut("" + e.key) : d.toString(36);
      }
      function Le(e, d, b, I, T) {
        var B = typeof e;
        (B === "undefined" || B === "boolean") && (e = null);
        var q = !1;
        if (e === null)
          q = !0;
        else
          switch (B) {
            case "string":
            case "number":
              q = !0;
              break;
            case "object":
              switch (e.$$typeof) {
                case s:
                case h:
                  q = !0;
              }
          }
        if (q) {
          var j = e, ae = T(j), se = I === "" ? Pe + je(j, 0) : I;
          if (Array.isArray(ae)) {
            var ue = "";
            se != null && (ue = Ye(se) + "/"), Le(ae, d, ue, "", function(rr) {
              return rr;
            });
          } else
            ae != null && (Ce(ae) && (ae = st(
              ae,
              // Keep both the (mapped) and old keys if they differ, just as
              // traverseAllChildren used to do for objects as children
              b + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
              (ae.key && (!j || j.key !== ae.key) ? (
                // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
                Ye("" + ae.key) + "/"
              ) : "") + se
            )), d.push(ae));
          return 1;
        }
        var ce, ve, he = 0, ye = I === "" ? Pe : I + lt;
        if (Array.isArray(e))
          for (var at = 0; at < e.length; at++)
            ce = e[at], ve = ye + je(ce, at), he += Le(ce, d, b, ve, T);
        else {
          var bt = p(e);
          if (typeof bt == "function") {
            var Nt = e;
            bt === Nt.entries && (We || F("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), We = !0);
            for (var er = bt.call(Nt), $t, tr = 0; !($t = er.next()).done; )
              ce = $t.value, ve = ye + je(ce, tr++), he += Le(ce, d, b, ve, T);
          } else if (B === "object") {
            var Ut = "" + e;
            throw Error("Objects are not valid as a React child (found: " + (Ut === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : Ut) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return he;
      }
      function Se(e, d, b) {
        if (e == null)
          return e;
        var I = [], T = 0;
        return Le(e, I, "", "", function(B) {
          return d.call(b, B, T++);
        }), I;
      }
      function Ge(e) {
        var d = 0;
        return Se(e, function() {
          d++;
        }), d;
      }
      function Ie(e, d, b) {
        Se(e, function() {
          d.apply(this, arguments);
        }, b);
      }
      function Me(e) {
        return Se(e, function(d) {
          return d;
        }) || [];
      }
      function qe(e) {
        if (!Ce(e))
          throw Error("React.Children.only expected to receive a single React element child.");
        return e;
      }
      function Ke(e, d) {
        d === void 0 ? d = null : d !== null && typeof d != "function" && x("createContext: Expected the optional second argument to be a function. Instead received: %s", d);
        var b = {
          $$typeof: m,
          _calculateChangedBits: d,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: e,
          _currentValue2: e,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null
        };
        b.Provider = {
          $$typeof: g,
          _context: b
        };
        var I = !1, T = !1, B = !1;
        {
          var q = {
            $$typeof: m,
            _context: b,
            _calculateChangedBits: b._calculateChangedBits
          };
          Object.defineProperties(q, {
            Provider: {
              get: function() {
                return T || (T = !0, x("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), b.Provider;
              },
              set: function(j) {
                b.Provider = j;
              }
            },
            _currentValue: {
              get: function() {
                return b._currentValue;
              },
              set: function(j) {
                b._currentValue = j;
              }
            },
            _currentValue2: {
              get: function() {
                return b._currentValue2;
              },
              set: function(j) {
                b._currentValue2 = j;
              }
            },
            _threadCount: {
              get: function() {
                return b._threadCount;
              },
              set: function(j) {
                b._threadCount = j;
              }
            },
            Consumer: {
              get: function() {
                return I || (I = !0, x("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), b.Consumer;
              }
            },
            displayName: {
              get: function() {
                return b.displayName;
              },
              set: function(j) {
                B || (F("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", j), B = !0);
              }
            }
          }), b.Consumer = q;
        }
        return b._currentRenderer = null, b._currentRenderer2 = null, b;
      }
      var ft = -1, Te = 0, Ze = 1, Je = 2;
      function Qe(e) {
        if (e._status === ft) {
          var d = e._result, b = d(), I = e;
          I._status = Te, I._result = b, b.then(function(T) {
            if (e._status === Te) {
              var B = T.default;
              B === void 0 && x(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, T);
              var q = e;
              q._status = Ze, q._result = B;
            }
          }, function(T) {
            if (e._status === Te) {
              var B = e;
              B._status = Je, B._result = T;
            }
          });
        }
        if (e._status === Ze)
          return e._result;
        throw e._result;
      }
      function dt(e) {
        var d = {
          // We use these fields to store the result.
          _status: -1,
          _result: e
        }, b = {
          $$typeof: S,
          _payload: d,
          _init: Qe
        };
        {
          var I, T;
          Object.defineProperties(b, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return I;
              },
              set: function(B) {
                x("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), I = B, Object.defineProperty(b, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return T;
              },
              set: function(B) {
                x("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), T = B, Object.defineProperty(b, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return b;
      }
      function ht(e) {
        e != null && e.$$typeof === R ? x("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof e != "function" ? x("forwardRef requires a render function but was given %s.", e === null ? "null" : typeof e) : e.length !== 0 && e.length !== 2 && x("forwardRef render functions accept exactly two parameters: props and ref. %s", e.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), e != null && (e.defaultProps != null || e.propTypes != null) && x("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var d = {
          $$typeof: v,
          render: e
        };
        {
          var b;
          Object.defineProperty(d, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return b;
            },
            set: function(I) {
              b = I, e.displayName == null && (e.displayName = I);
            }
          });
        }
        return d;
      }
      var Xe = !1;
      function et(e) {
        return !!(typeof e == "string" || typeof e == "function" || e === r.Fragment || e === r.Profiler || e === H || e === r.StrictMode || e === r.Suspense || e === w || e === W || Xe || typeof e == "object" && e !== null && (e.$$typeof === S || e.$$typeof === R || e.$$typeof === g || e.$$typeof === m || e.$$typeof === v || e.$$typeof === D || e.$$typeof === O || e[0] === C));
      }
      function pt(e, d) {
        et(e) || x("memo: The first argument must be a component. Instead received: %s", e === null ? "null" : typeof e);
        var b = {
          $$typeof: R,
          type: e,
          compare: d === void 0 ? null : d
        };
        {
          var I;
          Object.defineProperty(b, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return I;
            },
            set: function(T) {
              I = T, e.displayName == null && (e.displayName = T);
            }
          });
        }
        return b;
      }
      function me() {
        var e = f.current;
        if (e === null)
          throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
        return e;
      }
      function vt(e, d) {
        var b = me();
        if (d !== void 0 && x("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", d, typeof d == "number" && Array.isArray(arguments[2]) ? `

Did you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://reactjs.org/link/rules-of-hooks` : ""), e._context !== void 0) {
          var I = e._context;
          I.Consumer === e ? x("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : I.Provider === e && x("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return b.useContext(e, d);
      }
      function c(e) {
        var d = me();
        return d.useState(e);
      }
      function k(e, d, b) {
        var I = me();
        return I.useReducer(e, d, b);
      }
      function L(e) {
        var d = me();
        return d.useRef(e);
      }
      function M(e, d) {
        var b = me();
        return b.useEffect(e, d);
      }
      function ee(e, d) {
        var b = me();
        return b.useLayoutEffect(e, d);
      }
      function te(e, d) {
        var b = me();
        return b.useCallback(e, d);
      }
      function K(e, d) {
        var b = me();
        return b.useMemo(e, d);
      }
      function Y(e, d, b) {
        var I = me();
        return I.useImperativeHandle(e, d, b);
      }
      function de(e, d) {
        {
          var b = me();
          return b.useDebugValue(e, d);
        }
      }
      var ie = 0, le, ge, Ee, ze, _e, wt, Ct;
      function Et() {
      }
      Et.__reactDisabledLog = !0;
      function jt() {
        {
          if (ie === 0) {
            le = console.log, ge = console.info, Ee = console.warn, ze = console.error, _e = console.group, wt = console.groupCollapsed, Ct = console.groupEnd;
            var e = {
              configurable: !0,
              enumerable: !0,
              value: Et,
              writable: !0
            };
            Object.defineProperties(console, {
              info: e,
              log: e,
              warn: e,
              error: e,
              group: e,
              groupCollapsed: e,
              groupEnd: e
            });
          }
          ie++;
        }
      }
      function Mt() {
        {
          if (ie--, ie === 0) {
            var e = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: n({}, e, {
                value: le
              }),
              info: n({}, e, {
                value: ge
              }),
              warn: n({}, e, {
                value: Ee
              }),
              error: n({}, e, {
                value: ze
              }),
              group: n({}, e, {
                value: _e
              }),
              groupCollapsed: n({}, e, {
                value: wt
              }),
              groupEnd: n({}, e, {
                value: Ct
              })
            });
          }
          ie < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var mt = P.ReactCurrentDispatcher, gt;
      function tt(e, d, b) {
        {
          if (gt === void 0)
            try {
              throw Error();
            } catch (T) {
              var I = T.stack.trim().match(/\n( *(at )?)/);
              gt = I && I[1] || "";
            }
          return `
` + gt + e;
        }
      }
      var _t = !1, rt;
      {
        var qt = typeof WeakMap == "function" ? WeakMap : Map;
        rt = new qt();
      }
      function St(e, d) {
        if (!e || _t)
          return "";
        {
          var b = rt.get(e);
          if (b !== void 0)
            return b;
        }
        var I;
        _t = !0;
        var T = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var B;
        B = mt.current, mt.current = null, jt();
        try {
          if (d) {
            var q = function() {
              throw Error();
            };
            if (Object.defineProperty(q.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(q, []);
              } catch (ye) {
                I = ye;
              }
              Reflect.construct(e, [], q);
            } else {
              try {
                q.call();
              } catch (ye) {
                I = ye;
              }
              e.call(q.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (ye) {
              I = ye;
            }
            e();
          }
        } catch (ye) {
          if (ye && I && typeof ye.stack == "string") {
            for (var j = ye.stack.split(`
`), ae = I.stack.split(`
`), se = j.length - 1, ue = ae.length - 1; se >= 1 && ue >= 0 && j[se] !== ae[ue]; )
              ue--;
            for (; se >= 1 && ue >= 0; se--, ue--)
              if (j[se] !== ae[ue]) {
                if (se !== 1 || ue !== 1)
                  do
                    if (se--, ue--, ue < 0 || j[se] !== ae[ue]) {
                      var ce = `
` + j[se].replace(" at new ", " at ");
                      return typeof e == "function" && rt.set(e, ce), ce;
                    }
                  while (se >= 1 && ue >= 0);
                break;
              }
          }
        } finally {
          _t = !1, mt.current = B, Mt(), Error.prepareStackTrace = T;
        }
        var ve = e ? e.displayName || e.name : "", he = ve ? tt(ve) : "";
        return typeof e == "function" && rt.set(e, he), he;
      }
      function It(e, d, b) {
        return St(e, !1);
      }
      function zt(e) {
        var d = e.prototype;
        return !!(d && d.isReactComponent);
      }
      function nt(e, d, b) {
        if (e == null)
          return "";
        if (typeof e == "function")
          return St(e, zt(e));
        if (typeof e == "string")
          return tt(e);
        switch (e) {
          case r.Suspense:
            return tt("Suspense");
          case w:
            return tt("SuspenseList");
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case v:
              return It(e.render);
            case R:
              return nt(e.type, d, b);
            case O:
              return It(e._render);
            case S: {
              var I = e, T = I._payload, B = I._init;
              try {
                return nt(B(T), d, b);
              } catch {
              }
            }
          }
        return "";
      }
      var Rt = {}, At = P.ReactDebugCurrentFrame;
      function it(e) {
        if (e) {
          var d = e._owner, b = nt(e.type, e._source, d ? d.type : null);
          At.setExtraStackFrame(b);
        } else
          At.setExtraStackFrame(null);
      }
      function Bt(e, d, b, I, T) {
        {
          var B = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var q in e)
            if (B(e, q)) {
              var j = void 0;
              try {
                if (typeof e[q] != "function") {
                  var ae = Error((I || "React class") + ": " + b + " type `" + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[q] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw ae.name = "Invariant Violation", ae;
                }
                j = e[q](d, q, I, b, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (se) {
                j = se;
              }
              j && !(j instanceof Error) && (it(T), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", I || "React class", b, q, typeof j), it(null)), j instanceof Error && !(j.message in Rt) && (Rt[j.message] = !0, it(T), x("Failed %s type: %s", b, j.message), it(null));
            }
        }
      }
      function xe(e) {
        if (e) {
          var d = e._owner, b = nt(e.type, e._source, d ? d.type : null);
          y(b);
        } else
          y(null);
      }
      var yt;
      yt = !1;
      function kt() {
        if (t.current) {
          var e = pe(t.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
      function Ht(e) {
        if (e !== void 0) {
          var d = e.fileName.replace(/^.*[\\\/]/, ""), b = e.lineNumber;
          return `

Check your code at ` + d + ":" + b + ".";
        }
        return "";
      }
      function Vt(e) {
        return e != null ? Ht(e.__source) : "";
      }
      var Pt = {};
      function Wt(e) {
        var d = kt();
        if (!d) {
          var b = typeof e == "string" ? e : e.displayName || e.name;
          b && (d = `

Check the top-level render call using <` + b + ">.");
        }
        return d;
      }
      function Lt(e, d) {
        if (!(!e._store || e._store.validated || e.key != null)) {
          e._store.validated = !0;
          var b = Wt(d);
          if (!Pt[b]) {
            Pt[b] = !0;
            var I = "";
            e && e._owner && e._owner !== t.current && (I = " It was passed a child from " + pe(e._owner.type) + "."), xe(e), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', b, I), xe(null);
          }
        }
      }
      function Tt(e, d) {
        if (typeof e == "object") {
          if (Array.isArray(e))
            for (var b = 0; b < e.length; b++) {
              var I = e[b];
              Ce(I) && Lt(I, d);
            }
          else if (Ce(e))
            e._store && (e._store.validated = !0);
          else if (e) {
            var T = p(e);
            if (typeof T == "function" && T !== e.entries)
              for (var B = T.call(e), q; !(q = B.next()).done; )
                Ce(q.value) && Lt(q.value, d);
          }
        }
      }
      function xt(e) {
        {
          var d = e.type;
          if (d == null || typeof d == "string")
            return;
          var b;
          if (typeof d == "function")
            b = d.propTypes;
          else if (typeof d == "object" && (d.$$typeof === v || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          d.$$typeof === R))
            b = d.propTypes;
          else
            return;
          if (b) {
            var I = pe(d);
            Bt(b, e.props, "prop", I, e);
          } else if (d.PropTypes !== void 0 && !yt) {
            yt = !0;
            var T = pe(d);
            x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", T || "Unknown");
          }
          typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Yt(e) {
        {
          for (var d = Object.keys(e.props), b = 0; b < d.length; b++) {
            var I = d[b];
            if (I !== "children" && I !== "key") {
              xe(e), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", I), xe(null);
              break;
            }
          }
          e.ref !== null && (xe(e), x("Invalid attribute `ref` supplied to `React.Fragment`."), xe(null));
        }
      }
      function Dt(e, d, b) {
        var I = et(e);
        if (!I) {
          var T = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (T += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var B = Vt(d);
          B ? T += B : T += kt();
          var q;
          e === null ? q = "null" : Array.isArray(e) ? q = "array" : e !== void 0 && e.$$typeof === s ? (q = "<" + (pe(e.type) || "Unknown") + " />", T = " Did you accidentally export a JSX literal instead of a component?") : q = typeof e, x("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, T);
        }
        var j = Ue.apply(this, arguments);
        if (j == null)
          return j;
        if (I)
          for (var ae = 2; ae < arguments.length; ae++)
            Tt(arguments[ae], e);
        return e === r.Fragment ? Yt(j) : xt(j), j;
      }
      var Ot = !1;
      function Gt(e) {
        var d = Dt.bind(null, e);
        return d.type = e, Ot || (Ot = !0, F("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(d, "type", {
          enumerable: !1,
          get: function() {
            return F("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: e
            }), e;
          }
        }), d;
      }
      function Kt(e, d, b) {
        for (var I = Ve.apply(this, arguments), T = 2; T < arguments.length; T++)
          Tt(arguments[T], I.type);
        return xt(I), I;
      }
      try {
        var Ft = Object.freeze({});
      } catch {
      }
      var Zt = Dt, Jt = Kt, Qt = Gt, Xt = {
        map: Se,
        forEach: Ie,
        count: Ge,
        toArray: Me,
        only: qe
      };
      r.Children = Xt, r.Component = U, r.PureComponent = oe, r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = P, r.cloneElement = Jt, r.createContext = Ke, r.createElement = Zt, r.createFactory = Qt, r.createRef = fe, r.forwardRef = ht, r.isValidElement = Ce, r.lazy = dt, r.memo = pt, r.useCallback = te, r.useContext = vt, r.useDebugValue = de, r.useEffect = M, r.useImperativeHandle = Y, r.useLayoutEffect = ee, r.useMemo = K, r.useReducer = k, r.useRef = L, r.useState = c, r.version = a;
    }();
  }(react_development)), react_development;
}
process.env.NODE_ENV === "production" ? react.exports = requireReact_production_min() : react.exports = requireReact_development();
var reactExports = react.exports;
const React = /* @__PURE__ */ getDefaultExportFromCjs(reactExports);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1, requireObjectAssign();
  var r = reactExports, n = 60103;
  if (reactJsxRuntime_production_min.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var a = Symbol.for;
    n = a("react.element"), reactJsxRuntime_production_min.Fragment = a("react.fragment");
  }
  var s = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, h = Object.prototype.hasOwnProperty, g = { key: !0, ref: !0, __self: !0, __source: !0 };
  function m(v, w, R) {
    var S, O = {}, C = null, D = null;
    R !== void 0 && (C = "" + R), w.key !== void 0 && (C = "" + w.key), w.ref !== void 0 && (D = w.ref);
    for (S in w)
      h.call(w, S) && !g.hasOwnProperty(S) && (O[S] = w[S]);
    if (v && v.defaultProps)
      for (S in w = v.defaultProps, w)
        O[S] === void 0 && (O[S] = w[S]);
    return { $$typeof: n, type: v, key: C, ref: D, props: O, _owner: s.current };
  }
  return reactJsxRuntime_production_min.jsx = m, reactJsxRuntime_production_min.jsxs = m, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, function(r) {
    process.env.NODE_ENV !== "production" && function() {
      var n = reactExports, a = requireObjectAssign(), s = 60103, h = 60106;
      r.Fragment = 60107;
      var g = 60108, m = 60114, v = 60109, w = 60110, R = 60112, S = 60113, O = 60120, C = 60115, D = 60116, H = 60121, W = 60122, N = 60117, z = 60129, Z = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var p = Symbol.for;
        s = p("react.element"), h = p("react.portal"), r.Fragment = p("react.fragment"), g = p("react.strict_mode"), m = p("react.profiler"), v = p("react.provider"), w = p("react.context"), R = p("react.forward_ref"), S = p("react.suspense"), O = p("react.suspense_list"), C = p("react.memo"), D = p("react.lazy"), H = p("react.block"), W = p("react.server.block"), N = p("react.fundamental"), p("react.scope"), p("react.opaque.id"), z = p("react.debug_trace_mode"), p("react.offscreen"), Z = p("react.legacy_hidden");
      }
      var f = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
      function t(c) {
        if (c === null || typeof c != "object")
          return null;
        var k = f && c[f] || c[l];
        return typeof k == "function" ? k : null;
      }
      var o = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function u(c) {
        {
          for (var k = arguments.length, L = new Array(k > 1 ? k - 1 : 0), M = 1; M < k; M++)
            L[M - 1] = arguments[M];
          y("error", c, L);
        }
      }
      function y(c, k, L) {
        {
          var M = o.ReactDebugCurrentFrame, ee = M.getStackAddendum();
          ee !== "" && (k += "%s", L = L.concat([ee]));
          var te = L.map(function(K) {
            return "" + K;
          });
          te.unshift("Warning: " + k), Function.prototype.apply.call(console[c], console, te);
        }
      }
      var E = !1;
      function P(c) {
        return !!(typeof c == "string" || typeof c == "function" || c === r.Fragment || c === m || c === z || c === g || c === S || c === O || c === Z || E || typeof c == "object" && c !== null && (c.$$typeof === D || c.$$typeof === C || c.$$typeof === v || c.$$typeof === w || c.$$typeof === R || c.$$typeof === N || c.$$typeof === H || c[0] === W));
      }
      function F(c, k, L) {
        var M = k.displayName || k.name || "";
        return c.displayName || (M !== "" ? L + "(" + M + ")" : L);
      }
      function x(c) {
        return c.displayName || "Context";
      }
      function $(c) {
        if (c == null)
          return null;
        if (typeof c.tag == "number" && u("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof c == "function")
          return c.displayName || c.name || null;
        if (typeof c == "string")
          return c;
        switch (c) {
          case r.Fragment:
            return "Fragment";
          case h:
            return "Portal";
          case m:
            return "Profiler";
          case g:
            return "StrictMode";
          case S:
            return "Suspense";
          case O:
            return "SuspenseList";
        }
        if (typeof c == "object")
          switch (c.$$typeof) {
            case w:
              var k = c;
              return x(k) + ".Consumer";
            case v:
              var L = c;
              return x(L._context) + ".Provider";
            case R:
              return F(c, c.render, "ForwardRef");
            case C:
              return $(c.type);
            case H:
              return $(c._render);
            case D: {
              var M = c, ee = M._payload, te = M._init;
              try {
                return $(te(ee));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var V = 0, re, _, A, U, G, J, Q;
      function X() {
      }
      X.__reactDisabledLog = !0;
      function oe() {
        {
          if (V === 0) {
            re = console.log, _ = console.info, A = console.warn, U = console.error, G = console.group, J = console.groupCollapsed, Q = console.groupEnd;
            var c = {
              configurable: !0,
              enumerable: !0,
              value: X,
              writable: !0
            };
            Object.defineProperties(console, {
              info: c,
              log: c,
              warn: c,
              error: c,
              group: c,
              groupCollapsed: c,
              groupEnd: c
            });
          }
          V++;
        }
      }
      function ne() {
        {
          if (V--, V === 0) {
            var c = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: a({}, c, {
                value: re
              }),
              info: a({}, c, {
                value: _
              }),
              warn: a({}, c, {
                value: A
              }),
              error: a({}, c, {
                value: U
              }),
              group: a({}, c, {
                value: G
              }),
              groupCollapsed: a({}, c, {
                value: J
              }),
              groupEnd: a({}, c, {
                value: Q
              })
            });
          }
          V < 0 && u("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var fe = o.ReactCurrentDispatcher, De;
      function Re(c, k, L) {
        {
          if (De === void 0)
            try {
              throw Error();
            } catch (ee) {
              var M = ee.stack.trim().match(/\n( *(at )?)/);
              De = M && M[1] || "";
            }
          return `
` + De + c;
        }
      }
      var pe = !1, be;
      {
        var Be = typeof WeakMap == "function" ? WeakMap : Map;
        be = new Be();
      }
      function Oe(c, k) {
        if (!c || pe)
          return "";
        {
          var L = be.get(c);
          if (L !== void 0)
            return L;
        }
        var M;
        pe = !0;
        var ee = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var te;
        te = fe.current, fe.current = null, oe();
        try {
          if (k) {
            var K = function() {
              throw Error();
            };
            if (Object.defineProperty(K.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(K, []);
              } catch (_e) {
                M = _e;
              }
              Reflect.construct(c, [], K);
            } else {
              try {
                K.call();
              } catch (_e) {
                M = _e;
              }
              c.call(K.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (_e) {
              M = _e;
            }
            c();
          }
        } catch (_e) {
          if (_e && M && typeof _e.stack == "string") {
            for (var Y = _e.stack.split(`
`), de = M.stack.split(`
`), ie = Y.length - 1, le = de.length - 1; ie >= 1 && le >= 0 && Y[ie] !== de[le]; )
              le--;
            for (; ie >= 1 && le >= 0; ie--, le--)
              if (Y[ie] !== de[le]) {
                if (ie !== 1 || le !== 1)
                  do
                    if (ie--, le--, le < 0 || Y[ie] !== de[le]) {
                      var ge = `
` + Y[ie].replace(" at new ", " at ");
                      return typeof c == "function" && be.set(c, ge), ge;
                    }
                  while (ie >= 1 && le >= 0);
                break;
              }
          }
        } finally {
          pe = !1, fe.current = te, ne(), Error.prepareStackTrace = ee;
        }
        var Ee = c ? c.displayName || c.name : "", ze = Ee ? Re(Ee) : "";
        return typeof c == "function" && be.set(c, ze), ze;
      }
      function Fe(c, k, L) {
        return Oe(c, !1);
      }
      function Ne(c) {
        var k = c.prototype;
        return !!(k && k.isReactComponent);
      }
      function Ae(c, k, L) {
        if (c == null)
          return "";
        if (typeof c == "function")
          return Oe(c, Ne(c));
        if (typeof c == "string")
          return Re(c);
        switch (c) {
          case S:
            return Re("Suspense");
          case O:
            return Re("SuspenseList");
        }
        if (typeof c == "object")
          switch (c.$$typeof) {
            case R:
              return Fe(c.render);
            case C:
              return Ae(c.type, k, L);
            case H:
              return Fe(c._render);
            case D: {
              var M = c, ee = M._payload, te = M._init;
              try {
                return Ae(te(ee), k, L);
              } catch {
              }
            }
          }
        return "";
      }
      var $e = {}, He = o.ReactDebugCurrentFrame;
      function ke(c) {
        if (c) {
          var k = c._owner, L = Ae(c.type, c._source, k ? k.type : null);
          He.setExtraStackFrame(L);
        } else
          He.setExtraStackFrame(null);
      }
      function ot(c, k, L, M, ee) {
        {
          var te = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var K in c)
            if (te(c, K)) {
              var Y = void 0;
              try {
                if (typeof c[K] != "function") {
                  var de = Error((M || "React class") + ": " + L + " type `" + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[K] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw de.name = "Invariant Violation", de;
                }
                Y = c[K](k, K, M, L, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ie) {
                Y = ie;
              }
              Y && !(Y instanceof Error) && (ke(ee), u("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", M || "React class", L, K, typeof Y), ke(null)), Y instanceof Error && !(Y.message in $e) && ($e[Y.message] = !0, ke(ee), u("Failed %s type: %s", L, Y.message), ke(null));
            }
        }
      }
      var we = o.ReactCurrentOwner, Ue = Object.prototype.hasOwnProperty, st = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ve, Ce, Pe;
      Pe = {};
      function lt(c) {
        if (Ue.call(c, "ref")) {
          var k = Object.getOwnPropertyDescriptor(c, "ref").get;
          if (k && k.isReactWarning)
            return !1;
        }
        return c.ref !== void 0;
      }
      function ut(c) {
        if (Ue.call(c, "key")) {
          var k = Object.getOwnPropertyDescriptor(c, "key").get;
          if (k && k.isReactWarning)
            return !1;
        }
        return c.key !== void 0;
      }
      function We(c, k) {
        if (typeof c.ref == "string" && we.current && k && we.current.stateNode !== k) {
          var L = $(we.current.type);
          Pe[L] || (u('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', $(we.current.type), c.ref), Pe[L] = !0);
        }
      }
      function ct(c, k) {
        {
          var L = function() {
            Ve || (Ve = !0, u("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", k));
          };
          L.isReactWarning = !0, Object.defineProperty(c, "key", {
            get: L,
            configurable: !0
          });
        }
      }
      function Ye(c, k) {
        {
          var L = function() {
            Ce || (Ce = !0, u("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", k));
          };
          L.isReactWarning = !0, Object.defineProperty(c, "ref", {
            get: L,
            configurable: !0
          });
        }
      }
      var je = function(c, k, L, M, ee, te, K) {
        var Y = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: s,
          // Built-in properties that belong on the element
          type: c,
          key: k,
          ref: L,
          props: K,
          // Record the component responsible for creating this element.
          _owner: te
        };
        return Y._store = {}, Object.defineProperty(Y._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Y, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: M
        }), Object.defineProperty(Y, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: ee
        }), Object.freeze && (Object.freeze(Y.props), Object.freeze(Y)), Y;
      };
      function Le(c, k, L, M, ee) {
        {
          var te, K = {}, Y = null, de = null;
          L !== void 0 && (Y = "" + L), ut(k) && (Y = "" + k.key), lt(k) && (de = k.ref, We(k, ee));
          for (te in k)
            Ue.call(k, te) && !st.hasOwnProperty(te) && (K[te] = k[te]);
          if (c && c.defaultProps) {
            var ie = c.defaultProps;
            for (te in ie)
              K[te] === void 0 && (K[te] = ie[te]);
          }
          if (Y || de) {
            var le = typeof c == "function" ? c.displayName || c.name || "Unknown" : c;
            Y && ct(K, le), de && Ye(K, le);
          }
          return je(c, Y, de, ee, M, we.current, K);
        }
      }
      var Se = o.ReactCurrentOwner, Ge = o.ReactDebugCurrentFrame;
      function Ie(c) {
        if (c) {
          var k = c._owner, L = Ae(c.type, c._source, k ? k.type : null);
          Ge.setExtraStackFrame(L);
        } else
          Ge.setExtraStackFrame(null);
      }
      var Me;
      Me = !1;
      function qe(c) {
        return typeof c == "object" && c !== null && c.$$typeof === s;
      }
      function Ke() {
        {
          if (Se.current) {
            var c = $(Se.current.type);
            if (c)
              return `

Check the render method of \`` + c + "`.";
          }
          return "";
        }
      }
      function ft(c) {
        {
          if (c !== void 0) {
            var k = c.fileName.replace(/^.*[\\\/]/, ""), L = c.lineNumber;
            return `

Check your code at ` + k + ":" + L + ".";
          }
          return "";
        }
      }
      var Te = {};
      function Ze(c) {
        {
          var k = Ke();
          if (!k) {
            var L = typeof c == "string" ? c : c.displayName || c.name;
            L && (k = `

Check the top-level render call using <` + L + ">.");
          }
          return k;
        }
      }
      function Je(c, k) {
        {
          if (!c._store || c._store.validated || c.key != null)
            return;
          c._store.validated = !0;
          var L = Ze(k);
          if (Te[L])
            return;
          Te[L] = !0;
          var M = "";
          c && c._owner && c._owner !== Se.current && (M = " It was passed a child from " + $(c._owner.type) + "."), Ie(c), u('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', L, M), Ie(null);
        }
      }
      function Qe(c, k) {
        {
          if (typeof c != "object")
            return;
          if (Array.isArray(c))
            for (var L = 0; L < c.length; L++) {
              var M = c[L];
              qe(M) && Je(M, k);
            }
          else if (qe(c))
            c._store && (c._store.validated = !0);
          else if (c) {
            var ee = t(c);
            if (typeof ee == "function" && ee !== c.entries)
              for (var te = ee.call(c), K; !(K = te.next()).done; )
                qe(K.value) && Je(K.value, k);
          }
        }
      }
      function dt(c) {
        {
          var k = c.type;
          if (k == null || typeof k == "string")
            return;
          var L;
          if (typeof k == "function")
            L = k.propTypes;
          else if (typeof k == "object" && (k.$$typeof === R || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          k.$$typeof === C))
            L = k.propTypes;
          else
            return;
          if (L) {
            var M = $(k);
            ot(L, c.props, "prop", M, c);
          } else if (k.PropTypes !== void 0 && !Me) {
            Me = !0;
            var ee = $(k);
            u("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ee || "Unknown");
          }
          typeof k.getDefaultProps == "function" && !k.getDefaultProps.isReactClassApproved && u("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function ht(c) {
        {
          for (var k = Object.keys(c.props), L = 0; L < k.length; L++) {
            var M = k[L];
            if (M !== "children" && M !== "key") {
              Ie(c), u("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", M), Ie(null);
              break;
            }
          }
          c.ref !== null && (Ie(c), u("Invalid attribute `ref` supplied to `React.Fragment`."), Ie(null));
        }
      }
      function Xe(c, k, L, M, ee, te) {
        {
          var K = P(c);
          if (!K) {
            var Y = "";
            (c === void 0 || typeof c == "object" && c !== null && Object.keys(c).length === 0) && (Y += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var de = ft(ee);
            de ? Y += de : Y += Ke();
            var ie;
            c === null ? ie = "null" : Array.isArray(c) ? ie = "array" : c !== void 0 && c.$$typeof === s ? (ie = "<" + ($(c.type) || "Unknown") + " />", Y = " Did you accidentally export a JSX literal instead of a component?") : ie = typeof c, u("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ie, Y);
          }
          var le = Le(c, k, L, ee, te);
          if (le == null)
            return le;
          if (K) {
            var ge = k.children;
            if (ge !== void 0)
              if (M)
                if (Array.isArray(ge)) {
                  for (var Ee = 0; Ee < ge.length; Ee++)
                    Qe(ge[Ee], c);
                  Object.freeze && Object.freeze(ge);
                } else
                  u("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Qe(ge, c);
          }
          return c === r.Fragment ? ht(le) : dt(le), le;
        }
      }
      function et(c, k, L) {
        return Xe(c, k, L, !0);
      }
      function pt(c, k, L) {
        return Xe(c, k, L, !1);
      }
      var me = pt, vt = et;
      r.jsx = me, r.jsxs = vt;
    }();
  }(reactJsxRuntime_development)), reactJsxRuntime_development;
}
process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports;
const ezEditorIndex = "";
class EZEditorView extends React.Component {
  constructor() {
    super(...arguments), this.wrapperID = "ez-wrapper-content", this.gotoStepAttribute = "goToCourseStep", this.wrapperDom = React.createRef();
  }
  componentDidMount() {
    if (this.wrapperDom.current != null) {
      const a = this.finalHtml();
      this.wrapperDom.current.innerHTML = a;
      var n = this.wrapperDom.current.querySelectorAll("script");
      this.buildScript(n, 0);
    }
    ezInitMain({
      holderSelector: "#" + this.wrapperID,
      baseUrl: this.props.baseUrl,
      clickActions: this.props.clickActions,
      contactId: this.props.currentUserId,
      userIsInFilter: this.props.userIsInFilter
    }), ezInitForms(this.props.formProps, () => typeof this.props.currentUserId != null), this.props.onCourseItemClick != null && document.querySelectorAll(`[${this.gotoStepAttribute}]`).forEach((a) => {
      a.addEventListener("click", () => {
        var h, g;
        const s = a.getAttribute(this.gotoStepAttribute);
        s && ((g = (h = this.props).onCourseItemClick) == null || g.call(h, s));
      });
    }), window[this.gotoStepAttribute] = this.props.onCourseItemClick;
  }
  finalHtml() {
    let n = this.props.html ?? "";
    const a = new RegExp('href="download:([^"]+)"', "g");
    if (n = n.replace(a, (s, h) => `href="${this.props.baseUrl}/file/download/${h}"`), this.props.onCourseItemClick != null) {
      const s = new RegExp('href="step:([^"]+)"', "g");
      n = n.replace(s, (h, g) => `${this.gotoStepAttribute}="${g}"`);
    }
    return n;
  }
  //this thing below is needed for script execution
  //need to do them in order load one after another. 
  //e.g. load jquery and then using $(document).ready() in this case will work
  buildScript(n, a) {
    const s = n[a];
    if (!s)
      return !0;
    const h = document.createElement("script");
    Array.from(s.attributes).forEach((m) => h.setAttribute(m.name, m.value));
    const g = !h.hasAttribute("src");
    g || (h.onload = () => this.buildScript(n, a + 1)), h.appendChild(document.createTextNode(s.innerHTML)), s.parentNode && s.parentNode.replaceChild(h, s), g && this.buildScript(n, a + 1);
  }
  render() {
    const n = ["ez-wrapper", "live"];
    return this.props.noCopy && n.push("no-copy"), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("style", { children: this.props.style }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: this.wrapperDom, id: this.wrapperID, className: n.join(" "), style: this.props.wrapperStyle, children: " " })
    ] });
  }
}
export {
  CountryCookieName,
  EZEditorView,
  emulateClick,
  ezInitForms,
  ezInitMain,
  isInsideWidget,
  makeIframesLazy
};
//# sourceMappingURL=index.js.map
